const locale = {
  accessInOut: "Entrada/Salida",
  addValidAttributeAndOptions: "Agregue un atributo y opciones válidos",
  allDay: "Todo el día",
  allDays: "Todos los días",
  allItems: "Todos los artículos",
  allPaymentTypes: "Todos los tipos de pago",
  apiInformation: "Información de la API",
  avgAmount: "Monto promedio",
  aWholeProductIsFinished:
    "Un producto completo es un producto terminado que puedes vender en tu espacio. Con las variantes, puedes elegir vender diferentes variaciones de este producto, como el sabor, el color y el tamaño. Todos los productos enteros y sus variantes tendrían cada uno su propio artículo de suministro.",
  accessControl: "Control de Acceso",
  accessControlRoleAppDesc: "Este rol no tiene acceso al sitio web.",
  accessControlRoleDashboardDesc: "Permitir acceso a la función Comprobar Acceso de la aplicación.",
  accessToken: "Token de acceso",
  accommodation: "Alojamiento",
  account: "Cuenta",
  accountAlreadyExists: "Este e-mail ya está asociado a una cuenta para este espacio",
  accountCantSeemToFind:
    "No hemos podido encontrar tu cuenta. Por favor, contacta con el mánager del espacio para pedir ayuda.",
  accountCode: "Cuenta creada con éxito",
  accountCodeAddedName: 'Cuenta "{0}" añadida.',
  accountCodeAlreadyExist: 'Cuenta "{0}" eliminada.',
  accountEmailAdded: "Mapeo de cuenta",
  accountEmailRemoved: "Configura y mapea tus cuentas al sistema SoCashlessVENUE.",
  accountIsActive: "Configuración de cuenta",
  accountMapping: "Tipo de cuenta",
  accountMappingDescription: "Código de cuenta",
  accountName: 'Código de cuenta "{0}" añadido.',
  accountNotFound: "Cuenta no encontrada",
  accountSettings: "Software de Contabilidad",
  accountType: "Nombre de la cuenta",
  accountingSoftware: "Software de contabilidad",
  accounts: "Cuentas",
  accrNo: "Accr#:",
  actions: "Acciones",
  activateInPos: "Activar en POS",
  activateOnPos: "Activar en punto de venta (POS)",
  activateVariant: "Activar variante",
  active: "Activo",
  activeDateRange: "Intervalo de fechas activo",
  actualClosingBalance: "Saldo final real",
  actualQty: "Cant. real",
  actualStockQty: "Cant. real de existencias",
  add: "Añadir",
  addANote: "Añadir una nota...",
  addAValidAttributeAndOptions: "Añadir un atributo válido y opciones.",
  addAWholeProduct: "Añadir un producto completo",
  addAccount: "Añadir cuenta",
  addAnotherAccount: "Añadir otra cuenta",
  addAnotherAttribute: "Añadir otro atributo",
  addAnotherProductOrSupplyItem: "Añadir otro producto o artículo de suministro",
  addAnotherSupplyItem: "Añadir otro artículo de suministro",
  addCustomQuestion: "Añadir pregunta personalizada",
  addNewAccount: "Añadir nueva cuenta",
  addNewAccountCode: "Ejecutar final del día",
  addNewAccountCodeName: 'Añadir nuevo código de cuenta "{0}"',
  addNewPaymentMethod: "Añadir nueva forma de pago",
  addNewSupplyItem: "Añadir nuevo artículo de suministro",
  addNewSupplyItemSelect: 'Añadir nuevo artículo de suministro "{0}"',
  addNewTax: "Añadir nuevo impuesto",
  addNote: "Añadir nota",
  addOption: "Añadir opción",
  addPaymentMethod: "Añadir método de pago",
  addProduct: "Añadir producto",
  addProducts: "Añadir productos o artículos de suministro en este conjunto de productos.",
  addQty: "Agregar cantidad",
  addSupplyItem: "Agregar artículo de suministro",
  addThisProduct: "Añadir este producto como nuevo producto y artículo de suministro.",
  addVariant: "Añadir variante",
  addedStock: "Stock añadido",
  additionalChargeReport: "Reporte de Cargos Adicionales",
  additionalCharges: "Cargos adicionales",
  adjustQuantity: "Ajustar cantidad",
  adjustStockSuccessfully: "Stock ajustado correctamente",
  adjustStocksSuccessfully: "Stock ajustado correctamente",
  adjustTheSupplyItemsVariant:
    "Ajustar artículos de suministro y cantidades para esta variante específica.",
  all: "Todos",
  allAccountTypes: "Todos los tipos de cuenta",
  allCategories: "Todas las categorías",
  allDevices: "Todos los descuentos",
  allDevicesUsed: "Todos los dispositivos usados",
  allDiscounts: "Todos los descuentos",
  allGuestProfiles: "Todos los perfiles de huéspedes",
  allLocation: "Todos los lugares",
  allLocations: "Todos",
  allMeasurements: "Todas las medidas",
  allPaymentMethods: "Todos los métodos de pago",
  allProducts: "Todos los productos",
  allReportsReadyForDownload: "Todos los informes listos para descargar",
  allRightsReserved: "Todos los derechos reservados.",
  allRoles: "Todos los roles",
  allSafeToDeleteLocation: "¡Hecho! No hay productos con esta ubicación.",
  allSelectedAvailablePos: "Todos los productos seleccionados estarán disponibles en POS.",
  allSelectedNotPos: "Los productos seleccionados no se mostrarán en tu POS.",
  allShiftsClosed: "Todos los turnos cerrados",
  allStaff: "Todo el personal",
  allStatus: "Todos los estados",
  allExternalPayments: "Todos",
  allStockLevels: "Todos los niveles de stock",
  allTransactions: "Todas las transacciones",
  allVoucherTypes: "Todos los tipos de vale",
  allVouchers: "Todos los vales",
  allowAccess: "Permitir acceso",
  allowAccessAndConnect: "Permitir acceso y conectar",
  allowBargainDesc: "Al marcar esto, el personal puede cambiar el precio del artículo en POS",
  allowBargainOnThisProduct: "Permitir negociar el valor final del producto",
  allowGuestWBKeeping: "Permitir que los huéspedes conserven sus etiquetas al finalizar.",
  allowOrRestrictGuestWBKeeping:
    "Permitir o restringir que los huéspedes conserven sus etiquetas al salir.",
  allowPostpaidAndLimit: "Permitir créditos de pospago y establecer límite",
  allowPostpaidInGuestProfile:
    "Permitir que este perfil de huésped realice compras sin créditos. Se les cobrará en el registro de salida.",
  allowThisGuestProfileLimit:
    "Permitir que este perfil de huésped haga compras sin créditos. Se les cobrará al salir.",
  allowedPaymentMethod: "Métodos de pago permitidos.",
  almostThere: "¡Ya casi está!",
  alreadyExists: "Ya existe.",
  amount: "Importe",
  anHourAgo: "hace una hora",
  and: "y",
  andWouldBe: "y sería",
  anyMoreQuestions: "¿Alguna otra pregunta? {0}",
  applyFilter: "Aplicar filtro",
  areYouSureYouWantToDeleteLocation:
    "¿Seguro que quieres eliminar {0}? El valor de inventario de esta ubicación actualmente es de {1}.",
  areYouSureYouWantToDeleteProduct:
    "¿Seguro que quieres eliminar {0}? Este artículo de suministro tiene actualmente {1} {2} en stock.",
  areYouSureYouWantToDeleteProduct2:
    "¿Seguro que quieres eliminar {0}? Dejará de estar disponible en tu espacio. Esto no afectará a las transacciones e informes anteriores.",
  areYouSureYouWantToRemoveVariant:
    '¿Seguro que quieres eliminar la variante "{0}"? Su artículo de suministro no se eliminará.',
  arrivalDate: "Fecha de llegada",
  arrivals: "Llegadas",
  askDeleteGuestProfile: "¿Borrar perfil de huésped?",
  askDeleteStaffProfile: "¿Borrar perfil de personal?",
  askGuestInfoCheckIn: "Pedir información del huésped durante el registro.",
  assemble: "Montar",
  assembleAProduct: "Montar un producto",
  asset: "Activo",
  assignAProfile: "Asignar un perfil",
  assignFreeCreditsStaff: "Asignar créditos gratuitos al personal de este grupo",
  assignVoucherStaff: "Asignar vales al personal de este grupo",
  assignVoucherToGuest: "Asignar vales a los huéspedes de este grupo al registrarse.",
  assignedRooms: "Habitaciones/camas asignadas",
  assignedSpace: "Espacio asignado",
  attribute: "Atributo",
  attributeAlreadyExists: "El nombre del atributo ya existe para este producto",
  automaticallyGenerateSku: "Generar SKU automáticamente",
  availability: "Disponibilidad",
  availabilityOnPos: "Disponibilidad en POS",
  availableAnytime: "Disponible siempre",
  availableEveryday: "Disponible todos los días",
  availableOnPos: "Disponible en el punto de venta (POS)",
  averageAmountPerItem: "Monto promedio por artículo",
  averageDurationOfStay: "Duración promedio de estancia",
  averageOrderValue: "Valor promedio de pedidos",
  awaitingInviteResponse: "Esperando respuesta de invitación.",
  back: "Volver",
  backOffice: "Panel administrativo",
  backOfficeRoleAppDesc:
    "Este rol no tiene roles relacionados con la aplicación y no podría iniciar sesión en el dispositivo.",
  backOfficeRoleDashboardDesc:
    "Permite el acceso a la información, las ventas, el personal, el perfil del invitado, los cupones, los descuentos, el perfil de la impresora y la configuración del panel.",
  banATag: "Bloquear una etiqueta",
  blockATag: "Bloquear una etiqueta",
  banDetails: "Detalles de bloqueo",
  banList: "Lista de bloqueos",
  blockedTags: "Etiquetas bloqueadas",
  banTag: "Bloquear etiqueta",
  banTagListSettings: "Configuración de la lista de etiquetas bloqueadas",
  banTags: "Bloquear etiquetas",
  bannedBy: "Bloqueado por",
  blockedBy: "Bloqueado por",
  bannedTags: "Etiquetas bloqueadas",
  banningThisTagWillOnlyTakeEffect:
    "El bloqueo de esta etiqueta se aplicará la próxima vez que tus dispositivos sean sincronizados y actualizados (normalmente cada 5 minutos cuando están conectados a Internet). Para reflejar estos cambios inmediatamente, por favor, sincroniza y actualiza tus dispositivos una vez que hayas bloqueado esta etiqueta.",
  basicInfo: "Info básica",
  belowParLevel: "Por debajo del nivel par",
  billAmount: "Importe de la factura",
  birthdate: "Fecha de nacimiento",
  birthday: "Cumpleaños",
  bookedBy: "Reservado por",
  bookingAmount: "Cantidad de reservas",
  bookingDescription: "Lleva un registro de todas las reservas de tu negocio.",
  bookingDetails: "Detalles de la reserva",
  bookingId: "ID de reserva",
  bookingList: "Lista de reservas",
  bookingNo: "Nº de reserva",
  bookingStatus: "Estado de reserva",
  bookingSummary: "Resumen de reservas",
  bookings: "Reservas",
  bottle: "botella",
  browseProducts: "Buscar productos",
  browseVouchers: "Examinar vales",
  businessAddress: "Dirección de la empresa",
  businessContactNumber: "Número de contacto de la empresa",
  businessDay: "Nombre de la empresa",
  businessDetails: "Detalles de la empresa",
  businessName: "Día laboral",
  byAssemblingAProduct:
    "Al montar un producto, puedes crear un producto con múltiples artículos de suministro, así como desglosar un solo artículo de suministro con variantes.",
  byCategory: "Por categoría",
  byCreatingPrinterProfiles:
    "Al crear perfiles de impresora, puedes configurar qué productos imprimir en las notas de pedidos para los diferentes puestos de tu espacio, como cocinas, bares, etc.",
  byGuest: "Por huésped",
  byItem: "Por artículo",
  byLocation: "Por ubicación",
  byStaff: "Por personal",
  cancel: "Cancelar",
  cancelBanTag: "Cancelar la etiqueta de bloqueo",
  cancelled: "Cancelado",
  cannotBeDeleted: "No se puede eliminar",
  cannotDeletePartOfComposite:
    "{0} no puede ser eliminado ya que forma parte de {1} compuesto {2}.",
  cantFindDesc: "¿No encuentras lo que buscas? Prueba con otra búsqueda o filtro.",
  capacity: "Capacidad",
  card: "Tarjeta",
  cash: "Efectivo",
  categories: "Categorías",
  categoriesDeleted: "{0} categorías eliminadas",
  categorizeAndManage: "Categoriza y gestiona cada transacción con el plan de cuentas.",
  category: "Categoría",
  categoryCreated: 'Categoría "{0}" creada.',
  categoryDeleted: 'Categoría "{0}" eliminada.',
  categoryList: "Lista de categorías",
  categoryName: "Nombre de categoría",
  categoryNameAlreadyExist: "El nombre de la categoría ya existe.",
  categoryNameReserved: "El nombre de la categoría está reservado. Por favor, utiliza otro nombre.",
  categoryReport: "Informe de categoría",
  categoryUpdated: 'Categoría "{0}" actualizada.',
  change: "Cambiar",
  changePassword: "Cambiar la contraseña",
  changePhoto: "Cambiar foto",
  changeRevenueAccount: "Cambiar cuenta de ingresos",
  changesSaved: "Cambios guardados.",
  changingCurrencyWontAffect:
    "El cambio de moneda no afectará al valor del precio de tus productos, solo a sus símbolos.",
  charge: "Cargo",
  chargeAmount: "Precio a cobrar",
  chargeName: "Nombre del cargo",
  chargeTaxesOnThisProduct: "Cargar los impuestos de este producto",
  chartOfAccounts: "Plan de cuentas",
  chartOfAccountsDescription: "Actualiza y gestiona tu plan de cuentas.",
  checkInDate: "Fecha de registro",
  checkInDetails: "Detalles del registro de entrada",
  checkInQuestions: "Preguntas sobre el registro de entrada",
  checkInSettings: "Configuración del registro de entrada",
  checkIns: "Registros de entrada",
  checkoutCreditsReturned: "Créditos devueltos al finalizar",
  checkOutDetails: "Detalles del registro de salida",
  checkoutPaymentCollected: "Pago cobrado al finalizar",
  checkOutTheGuide: "Consulta la guía para conectar las integraciones",
  checkOuts: "Salidas",
  checkStocks: "Comprobar existencias",
  checkYourEmail: "Verifica tu e-mail",
  checkYourEmailAt: "Verifica tu e-mail en {0} para completar la configuración de tu cuenta.",
  checkYourEmailOrAdmin: "Verifica tu e-mail o contacta con el administrador.",
  checkbox: "Checkbox",
  checkedIn: "Registrado en",
  checkedInBy: "Registrado por",
  checkedInDate: "Fecha de entrada",
  checkedOut: "Registro de salida realizado",
  checkedOutBy: "Registrado por",
  checkedOutDate: "Fecha de salida",
  checkedOutOn: "Registro de salida realizado el",
  checkinId: "ID de registro de entrada",
  checkingYourInternet: "Comprobando la conexión a Internet o datos.",
  checkout: "Salida",
  chooseAPassword: "Utiliza una contraseña fuerte que no utilices en otro sitio.",
  chooseAReason: "Elige un motivo",
  chooseASimpleOrMultipleItem: "Elige uno o varios artículos para crear un producto.",
  chooseAVenue: "Elige un espacio",
  chooseAtleast1Location: "Elige al menos 1 ubicación",
  chooseCategoryColor: "Elige un color para esta categoría",
  chooseColumns: "Elige las columnas que quieres ver en este informe.",
  chooseInformation: "Elige la información que quieres incluir en el desglose de ventas.",
  chooseLocationForThisStaff: "Elige la designación de la ubicación(es) para este personal",
  choosePassword: "Elige la contraseña",
  choosePaymentMethod: "Elige el método de pago",
  chooseProductsCanBeDiscounted: "Elige qué productos del inventario pueden ser descontados.",
  chooseRole: "Elige el rol(es) del personal",
  chooseTheLocationWhereThisProduct:
    "Elige los lugares donde se vende este producto y donde se descuentan los suministros.",
  chooseVouchers: "Elige los vales",
  cityStateCountry: "Ciudad, Estado, País, Código Postal",
  clear: "Eliminar",
  clearAllFilters: "Eliminar todos los filtros",
  clearDownloads: "Eliminar descargas",
  clearedTags: "Etiquetas eliminadas",
  clearedUnusedAndExpiredCredits: "Créditos eliminados, no utilizados y caducados",
  clearedUnusedAndExpiredCreditsMessage:
    "Para los créditos que han sido recargados pero eliminados, no reembolsables o están caducados.",
  clearedUnusedAndExpiredCreditsPlaceholder: "[xxxx] - Otros ingresos (caducidad)",
  clearedUnusedExpiredCredit: "Otros ingresos (caducidad)",
  clickHereToRetry: "Haz clic aquí para volver a intentarlo.",
  closePreview: "Cerrar vista previa",
  closeReceiptPreview: "Cerrar vista previa del recibo",
  cloudbedsDescription: "Gestión hotelera que mantiene su recepción y los datos de huéspedes en un solo lugar.",
  cloudbedsPropertyName: "Nombre de la propiedad en Cloudbeds",
  code: "Código",
  coffeeBeans: "granos de café",
  columns: "Columnas",
  combineYourProducts: "Combina tus productos para venderlos como un conjunto.",
  communityGuidelines: "guías de la comunidad",
  companyDetails: "Datos de la empresa",
  completeStocktake: "Completar inventario",
  completeStocktakeConfirmation: "¿Completar {0}?",
  completeSubscription: "Completar suscripción",
  completeThisIntegrationByAssigning: "Complete esta integración asignando puntos de venta/servicios en las configuraciones a continuación.",
  completeThisIntegrationByAssigningShort: "Complete esta integración asignando puntos de venta/servicios en sus configuraciones.",
  completeYourSubscription: "Completa tu suscripción para acceder a tu espacio",
  completed: "Completado",
  completedBy: "Completado por",
  completedOn: "Completado en",
  composite: "Compuesto",
  composition: "Composición",
  compositionGuide: "Guía de composición",
  confirmPassword: "Confirmar contraseña",
  confirmStockAdjustment: "Confirmar ajuste de stock",
  confirmTransfer: "Confirmar transferencia",
  confirmed: "Confirmado",
  connectAndInstall: "Conectar e instalar",
  contactUsAction: "Contáctenos",
  coordinates: "Coordenadas",
  costOfGoods: "Costo de bienes",
  creditExpirationOnCheckout: "Vencimiento de créditos al finalizar la estancia",
  creditFlow: "Flujo de créditos",
  creditStatus: "Estado del crédito",
  creditsKeptOutlet: "Punto de venta de créditos retenidos",
  creditsReceivedOutlet: "Punto de venta de créditos recibidos",
  customIntegrations: "Integraciones personalizadas",
  denominationGroupDescription: "Este grupo de denominaciones serán las opciones disponibles en la pantalla de recarga de su aplicación del establecimiento.",
  detailedAccessControl: "Control de acceso detallado",
  duplication: "Duplicación",
  eatAppDescription: "Reservas, gestión de mesas y perfiles de huéspedes para salones concurridos.",
  eatAppId: "ID de Eat App",
  editOutletsAndService: "Editar puntos de venta y servicio",
  editRevenueAccount: "Editar cuenta de ingresos",
  enterEatAppRoomId: "Ingrese el ID de sala de Eat App",
  enterEatAppRoomIdToMap: "Ingrese el ID de sala de Eat App para vincularlo con este perfil de huésped.",
  erpAndAccounting: "ERP y contabilidad",
  errorProcessingProductData: "Error al procesar los datos del producto. Inténtelo de nuevo.",
  eventEndDate: "Fecha de fin del evento",
  eventId: "ID del evento",
  eventName: "Nombre del evento",
  eventStartDate: "Fecha de inicio del evento",
  exportFailed: "Error al exportar",
  externalTicketId: "ID de ticket externo",
  finishIntegration: "Finalizar integración",
  firmware: "Firmware",
  fixed: "Fijo",
  friday: "Viernes",
  fromThisArticle: "de este artículo",
  fullLabel: "Completo",
  grossMargin: "Margen bruto",
  hereAreSomeTroubleshootingSteps: "Aquí tiene algunos pasos de solución de problemas.",
  howToFindYourAccessToken: "Cómo encontrar su token de acceso",
  imei: "IMEI",
  lastLocation: "Última ubicación",
  lastSeen: "Visto por última vez",
  linkedService: "Servicio vinculado",
  lobbyDescription: "Software para hoteles, hostales, glampings y casas de huéspedes.",
  mapLoadingError: "Error al cargar el mapa",
  mappingGuestProfileWithEatApp: "Vinculación del perfil de huésped con Eat App",
  maxAmount: "Monto máximo",
  mewsAccountingIntegrationRequirements: "Requisitos de la integración de MEWS Accounting",
  mewsDashboard: "Panel de MEWS",
  mewsDescription: "Simplifica y automatiza las operaciones diarias para hoteleros modernos.",
  mewsDisconnectionMessage: "¿Seguro que desea desconectarse de Mews? Esta integración y toda la información de Mews se eliminarán de su establecimiento.",
  mewsInstructionStep1: "1. Vaya a su",
  mewsInstructionStep2: "2. Vaya a Menú principal > Marketplace.",
  mewsInstructionStep3: "3. Busque “SoCashless”, haga clic en “Explore” y luego en “Connect Integration”. Si SoCashless ya está conectado, continúe con el siguiente paso.",
  mewsInstructionStep4: "4. Busque “SoCashless” en My Subscriptions y haga clic en Edit.",
  mewsInstructionStep5End: "en la esquina superior derecha y copie el token de acceso.",
  mewsInstructionStep5Start: "5. Haga clic en el icono de llave",
  mewsOutletSyncDescription: "Todas las transacciones se sincronizan con puntos de venta específicos en MEWS según el tipo de transacción. Recomendamos crear puntos de venta nuevos específicos para las transacciones realizadas en la aplicación. Para saber cómo crear puntos de venta en MEWS, siga el paso \"Create an outlet\"",
  mewsPropertyName: "Nombre de la propiedad en MEWS",
  mewsServiceSyncDescription: "Todas las transacciones sincronizadas deben vincularse a un servicio \"Additional\" creado en MEWS. Recomendamos crear un servicio nuevo para asociar las transacciones realizadas en la aplicación. Para saber cómo crear un servicio adicional en MEWS, siga el paso \"Create an additional service\"",
  mewsTroubleshootingStep1Desc: "Asegúrese de que el estado de su integración de MEWS Accounting no sea \"Parcialmente conectado\". Si tiene ese estado en la página de integraciones, significa que aún no ha configurado sus puntos de venta y servicios. Haga clic en el botón \"Finalizar integración\" para completar el proceso.",
  mewsTroubleshootingStep1Title: "Paso n.º 1: Configure sus puntos de venta y servicios",
  mewsTroubleshootingStep2DescEnd: "le muestra los pasos para hacerlo.",
  mewsTroubleshootingStep2DescStart: "Dado que la aplicación funciona de forma híbrida (sin conexión y en línea), debemos asegurarnos de que sus transacciones puedan sincronizarse con MEWS incluso si hay una interrupción prolongada de la red. Por eso recomendamos configurar la \"ventana de historial editable de contabilidad\" en 7 días desde su configuración de MEWS.",
  mewsTroubleshootingStep2Title: "Paso n.º 2: Edite la ventana de historial editable de contabilidad",
  mewsTroubleshootingStep3DescMiddle: "sea la misma que la configurada en su cuenta de MEWS",
  mewsTroubleshootingStep3DescStart: "Asegúrese de que la moneda configurada en su panel del establecimiento",
  mewsTroubleshootingStep3Hint1: "(puede encontrarlo en Configuración > General)",
  mewsTroubleshootingStep3Hint2: "(Configuración > Propiedad > Globalización > Moneda predeterminada)",
  mewsTroubleshootingStep3Title: "Paso n.º 3: Verifique la configuración de moneda",
  mewsTroubleshootingStep4Desc: "Las transacciones que no estén vinculadas a un huésped de MEWS se sincronizarán después de realizar el procedimiento de cierre de día. Recomendamos ejecutar el cierre de día al menos una vez al día.",
  mewsTroubleshootingStep4Title: "Paso n.º 4: Asegúrese de ejecutar su cierre de día",
  mewsTroubleshootingSteps: "Pasos de solución de problemas de MEWS",
  minAmount: "Monto mínimo",
  monday: "Lunes",
  needSomethingElse: "¿Necesita algo más?",
  noDataMatchesTheseFilters: "Ningún dato coincide con estos filtros.",
  noDevicesAvailable: "No hay dispositivos disponibles",
  noPaymentGatewaysFound: "No se encontraron pasarelas de pago",
  notAvailable: "N/D",
  noValidMapCoordinates: "No se encontraron coordenadas de mapa válidas para el dispositivo seleccionado.",
  nttDataDescription: "Adquirencia de tarjetas y procesamiento de pagos para transacciones en el establecimiento.",
  nttDataPaymentGatewayEnquiry: "NTT DATA Payment Gateway enquiry",
  connected: "Conectado",
  contactNumber: "Número de contacto",
  contactUs: "contáctanos",
  contactUs2: "Contacta con nosotros",
  continue: "Continuar",
  continueAs: "Continuar como {0}",
  continueBanningThisTag: "¿Continuar bloqueando esta etiqueta?",
  continuingOnThisPageWillLogout: "Al continuar en esta página, se cerrará la sesión actual.",
  copied: "¡Copiado!",
  copyLink: "Copiar enlace",
  copyrightYear: "Copyright © 2026",
  costOfGoodsSold: "Coste de las mercancías vendidas (COGS)",
  costOfGoodsSoldMessage: "La cuenta por defecto para el coste de un suministro una vez vendido.",
  costOfGoodsSoldPlaceholder: "[xxxx] - COGS/COGS",
  country: "País",
  createALocation: "Crear una ubicación",
  createAccount: "Crear cuenta",
  createAndManageProducts:
    "Crea y gestiona los productos que quieres vender en tus puntos de venta",
  createAndManageRawMaterials:
    "Crea y gestiona las materias primas y sus existencias para cada ubicación.",
  createAndManagerDiscounts: "Crea y gestiona tus descuentos con productos rebajados",
  createAndManagerVouchers: "Crea y gestiona tus vales utilizados para canjear productos",
  createCategoriesToLink: "Crea categorías para vincular y categorizar tus productos",
  createCategory: "Crear categoría",
  createDiscountPage: "Crear página de descuentos",
  createLocation: "Crear ubicación",
  createLocationToStoreYourProducts: "Crea una ubicación para almacenar tus productos.",
  createNewCategory: "Crear nueva categoría",
  createNewCharge: "Crear nuevo cargo",
  createNewDiscount: "Crear nuevo descuento",
  createNewGuestProfile: "Crear nuevo perfil de huésped",
  createNewLocation: "Crear nueva ubicación",
  createNewProduct: "Crear nuevo producto",
  createNewProductSet: "Crear nuevo conjunto de productos",
  createNewProfile: "Crear nuevo perfil",
  createNewStaffProfile: "Crear nuevo perfil de personal",
  createNewStocktake: "Crear nuevo inventario",
  createNewSupplyItem: "Crear nuevo artículo de suministro",
  createNewVoucher: "Crear nuevo vale",
  createNote: "Crear nota",
  createPrinterProfile: "Crear perfil de impresora",
  createProduct: "Crear producto",
  createProductSet: "Crear conjunto de productos",
  createStaffProfile: "Crear perfil de personal",
  createStaffWhoCan:
    "Crea personal que pueda recargar créditos, registrar huéspedes y vender en tus espacios.",
  createTheProduct: "Crea los productos que quieras vender en tu espacio.",
  createVoucherPage: "Crea una página de vale",
  createVouchersForGuest: "Crea vales para los huéspedes y el personal.",
  createYourOwnIntegration: "Crea tus propias integraciones con SoCashlessCONNECT",
  createYourVenue: "Crea tu espacio",
  createdSupplyItem: "Artículo de suministro creado",
  credit: "Crédito",
  creditAutomaticallyExpires: "Los créditos caducan automáticamente después del registro de salida",
  creditBalance: "Saldo a favor",
  creditLimits: "Límites de crédito",
  creditSettings: "Ajustes de crédito",
  credits: "Créditos",
  creditsDescription:
    "Asigna créditos gratuitos a los huéspedes de este grupo y establece un límite de crédito de pospago.",
  creditsExpiration: "Vencimiento de los créditos",
  creditsExpirationDescription:
    "Configura los créditos para que venzan cuando un huésped haya salido.",
  creditsExpirationOnCheckout: "Vencimiento de los créditos a la salida",
  creditsLiabilityAccount: "Cuenta de pasivo de créditos",
  creditsLiabilityAccountMessage:
    "Cuenta de reserva para todos los créditos que se recargan en una etiqueta antes de la venta.",
  creditsLiabilityAccountPlaceholder: "[xxxx] - Responsabilidad/Créditos",
  creditsNeverExpires: "Los créditos nunca caducarán después de la salida.",
  creditsWouldNeverExpire: "Los créditos nunca caducarán cuando un huésped se haya registrado.",
  dashboardCreditsKept: "Créditos retenidos",
  dashboardCreditsReceived: "Créditos recibidos",
  currency: "Moneda",
  currencyAndFormat: "Moneda y formato",
  currentGuestProfiles: "Perfil actual de huéspedes",
  currentPassword: "Contraseña actual",
  currentPasswordAndNewPasswordMatched: "La contraseña actual y la nueva coinciden",
  currentQty: "Cantidad actual",
  custom: "Personalizar",
  customDateTime: "Personalizar fecha y hora",
  customFields: "Personalizar campos",
  customQuestion: "Personalizar pregunta",
  customQuestions: "Personalizar preguntas",
  customTax: "Personalizar impuestos",
  customerBehaviourOverTime: "Comportamiento del cliente en el tiempo",
  customizeReceipt: "Personaliza cada sección de tu recibo.",
  customizeSectionReceipt: "Personaliza las secciones de tu recibo.",
  dashboard: "Panel de control",
  dataError: "Error de datos",
  dataIncorrectly: "Datos incorrectos",
  date: "Fecha",
  dates: "Fechas",
  dateAndTimeOfTransaction: "Fecha y hora de la transacción",
  dateBanned: "Fecha de bloqueo",
  dateBlocked: "Fecha de bloqueo",
  dateCreated: "Fecha de creación",
  dateIssuedWithColonSymbol: "Fecha de emisión:",
  dateModified: "Fecha de modificación",
  dateOfCheckin: "Fecha de entrada",
  dateOfCheckout: "Fecha de salida",
  dateOfRegistration: "Fecha de registro",
  dateRange: "Rango de fechas",
  day: "día",
  days: "días",
  daysAfterCheckout: "días después de la salida",
  debitCredit: "Tarjeta de débito / crédito",
  default: "Por defecto",
  defaultAccountForTaxes: "La cuenta por defecto para los impuestos cargados por cada producto.",
  defaultFields: "Campos por defecto",
  defaultQuestions: "Preguntas por defecto",
  defaultRevenueAccount: "Cuenta de ingresos por defecto",
  defaultRevenueAccountMessage: "La cuenta por defecto para todos los ingresos por ventas.",
  defaultTax: "Impuestos por defecto",
  defectiveTag: "Etiqueta defectuosa",
  defectiveTags: "Etiquetas defectuosas",
  delete: "Eliminar",
  deleteAProduct: "Eliminar producto",
  deleteAProduct2: "¿Eliminar producto?",
  deleteAProductSet: "Eliminar conjunto de productos",
  deleteCategories: "Eliminar {0} categorías",
  deleteCategory: "Eliminar categoría",
  deleteCurrentlyBeingUsed:
    "{0} se está utilizando actualmente en algunos conjuntos de productos. Para continuar, elimina este producto de los siguientes conjuntos de productos",
  deleteDiscount: "Eliminar descuento",
  deleteGuestProfile: "Eliminar perfil de huésped",
  deleteLocation: "Eliminar ubicación",
  deleteLocationNote:
    "Aviso: las transacciones realizadas anteriormente con esta ubicación se conservarán.",
  deleteName: '¿Eliminar "{0}"?',
  deleteNote: "Eliminar aviso",
  deletePaymentMethod: "Eliminar método de pago",
  deletePrinterProfile: "Eliminar perfil de impresora",
  deleteProduct: "¿Eliminar {0}?",
  deleteProductSet: "¿Eliminar el conjunto de productos?",
  deleteProducts: "¿Eliminar {0} productos?",
  deleteProducts2: "Eliminar {0} productos",
  deleteQuestion: "Eliminar pregunta",
  deleteSelectedCategories: "Eliminar categorías seleccionadas",
  deleteSelectedCategory: "Eliminar categoría seleccionada",
  deleteSelectedProduct: "Eliminar producto seleccionado",
  deleteSelectedProducts: "Eliminar productos seleccionados",
  deleteStaff: "Eliminar personal",
  deleteStaffProfile: "Eliminar perfil del personal",
  deleteSupplyItem: "Eliminar artículo de suministro",
  deleteTax: "Eliminar impuestos",
  deleteThis: "Eliminar este {0}",
  deleteThisMultiple: "¿Eliminar {0} {1}?",
  deleteThisQuestion: "¿Eliminar esta pregunta?",
  deleteVoucher: "Eliminar vale",
  deleted: "Eliminado",
  deletedPaymentMethod: 'Forma de pago "{0}" eliminada.',
  deletedTax: 'Impuesto "{0}" eliminado.',
  deletingLoading: "Eliminando...",
  deletingName: "Eliminando {0}",
  deletingThisLocation:
    "Al eliminar esta ubicación también se eliminarán los saldos de existencias de todos los artículos de suministro. Esta acción no se puede deshacer.",
  denominations: "Denominaciones",
  departure: "Salida",
  departureDate: "Fecha de salida",
  describeThisProduct: "Describe este producto...",
  describeThisProductSet: "Describe este conjunto de productos",
  description: "Descripción",
  destinationLocation: "Ubicación de destino",
  destinationLocationNewQty: "Ubicación de destino nueva cantidad",
  deviceId: "ID del dispositivo",
  deviceImei: "IMEI del dispositivo",
  deviceImeiSerial: "IMEI del dispositivo / Serie",
  deviceInfo: "Información del dispositivo",
  deviceList: "Lista de dispositivo",
  deviceMac: "Dirección MAC del dispositivo",
  deviceMacAddress: "Dirección MAC del dispositivo",
  deviceName: "Nombre del dispositivo",
  deviceNameAlreadyExists: "El nombre del dispositivo ya existe",
  deviceNameUpdated: 'Dispositivo "{0}" actualizado.',
  deviceSerialNumber: "Número de serie del dispositivo",
  devices: "Dispositivos",
  difference: "Diferencia",
  disableSellingOnPos: "Desactivar la venta en POS",
  discard: "Descartar",
  discardChanges: "Descartar cambios",
  discardWristbandKeepingSettings: "Descartar configuración de mantenimiento de la pulsera",
  disclaimerCategoryReport:
    "Claúsula de exención de responsabilidad: Puede haber productos con múltiples categorías asignadas, lo que dará lugar a un doble recuento en cada partida.",
  disconnect: "Desconectar",
  discount: "Descuento",
  discountApplied: "Descuento aplicado",
  discountCanBeApplied: "Este descuento se puede aplicar en tu espacio.",
  discountCreated: 'Descuento "{0}" creado.',
  discountDeleted: 'Descuento "{0}" eliminado.',
  discountName: "Nombre del descuento",
  discountNameAlreadyExist: "Este nombre ya existe.",
  discountRateOrValue: "Tasa o valor de descuento",
  discountReport: "Informe de descuento",
  discountType: "Tipo de descuento",
  discountUpdated: 'Descuento "{0}" actualizado.',
  discountableProducts: "Productos con descuento",
  discounts: "Descuentos",
  discountsPage: "Página de descuentos",
  discrepancy: "Discrepancia",
  displayCategoryInPos: "Mostrar esta categoría en los dispositivos POS.",
  displayedIn: "Visualizado en",
  distribution: "Distribución",
  done: "Hecho",
  dontSellOnPos: "No vender en POS",
  dontWorry: "No te preocupes",
  download: "Descargar",
  downloading: "Descargando...",
  dropdown: "Desplegable",
  duplicateOption: "Opción de duplicado",
  eWallet: "E-wallet",
  easierGuestReg: "Facilitar el registro y la entrada de huéspedes",
  eatAppId: "ID de Eat App",
  eatAppIdPlaceholder: "Introduce el ID de sala de Eat App",
  eatAppMapping: "Asignación del perfil del huésped con Eat App",
  eatAppMappingDescription: "Introduce el ID de sala de Eat App para asignarlo a este perfil de huésped.",
  edit: "Editar",
  editAccessToken: "Editar token de acceso",
  editAccount: "Editar cuenta",
  editCategory: "Editar categoría",
  editDevices: "Editar dispositivo",
  editDiscountsPage: "Editar Página de descuento",
  editGuestProfile: "Editar el perfil del huésped",
  editLocation: "Editar ubicación",
  editLocations: "Editar puntos de venta",
  editNewCategory: "Editar nueva categoría",
  editNote: "Editar Nota",
  editPaymentMethod: "Editar método de pago",
  editPaymentMethods: "Editar métodos de pago",
  editPrinter: "Editar perfil de impresora",
  editPrinterProfile: "Editar perfil de impresora",
  editProduct: "Editar producto",
  editProductSet: "Editar conjunto de productos",
  editQuestions: "Editar preguntas",
  editStaff: "Editar personal",
  editStaffPage: "Editar página del personal",
  editStaffProfilePage: "Editar página de perfil del personal",
  editSupplyItem: "Editar artículo de suministro",
  editTax: "Editar impuestos",
  editVariants: "Editar variantes",
  editVoucherPage: "Editar la página de vales",
  editYourAccountPreferences: "Editar preferencias de tu cuenta, dirección de e-mail y contraseña.",
  egAppliesToGuests: "p. ej. Se aplica a los huéspedes de 60 años o más",
  egSeniorDiscount: "p. ej. Descuento para personas mayores",
  egSizeFlavor: "p. ej. Tamaño, sabor",
  eightCharactersMinimum: "8 caracteres como mínimo",
  eitherYouHavePoorConnection:
    "Puede que haya una mala conexión a internet, el acceso haya sido denegado o algo haya ido mal.",
  email: "Correo electrónico",
  emailAddress: "Dirección de e-mail",
  emailAlreadyInVenue: "Esta dirección de e-mail ya está asociada a una cuenta en este espacio.",
  emailDoesntHaveRecord:
    "El e-mail que has introducido no coincide con nuestro registro, por favor, vuelve a comprobarlo e inténtalo de nuevo.",
  enableSellingOnPos: "Activar venta en POS",
  end: "Finalizar",
  endDay: "Finalizar día",
  endOfDay: "Final del día",
  endOfDayChecklist: "Checklist del final de día",
  endOfDayReports: "Lista de control final del día",
  enterEachOption: "Introduce cada opción separada por una coma",
  enterEmailToLogin: "Introduce tu e-mail para iniciar sesión.",
  enterYourEmailAddress: "Introduce tu dirección de e-mail",
  enterYourPassword: "Introduce tu contraseña",
  enteredPasswordIncorrect: "La contraseña introducida es incorrecta.",
  equity: "Capital",
  errorLoadingColors: "Error al cargar los colores. Por favor, inténtalo de nuevo más tarde.",
  example1: "Ejemplo 1",
  example1AssembleProduct:
    "{0}: Un café con leche necesitaría {1}, {2} y {3}. La deducción se extraería de los granos de café, la leche y el azúcar cuando se compre un café con leche.",
  example2: "Ejemplo 2",
  example2AssembleProduct:
    '{0}: El vino puede venderse como un {1} o un {2}. Selecciona el vino como artículo de suministro, crea las variantes "botella" y "copa" y ajusta la cantidad del artículo por variante, de manera que sea deducido acorde con el mismo artículo de suministro.',
  expStockQty: "Exp. cantidad de stock",
  expectedEndingBalance: "Saldo final esperado",
  expectedQty: "Cant. esperada",
  expense: "Gasto",
  expired: "Caducado",
  export: "Exportar",
  exportCheckinDetails: "Exportar detalles de registro",
  exportList: "Exportar lista",
  exportRegisterReport: "Exportar informe de registro",
  exportTaxReport: "Exportar reporte de impuestos",
  exportTransactions: "Exportar transacciones",
  exportXlsx: "Exportar como XLSX",
  extendThePower: "Impulsa SoCashlessVENUE con los mejores complementos en su clase.",
  extremelyHighDenominations: "Denominaciones extremadamente altas",
  failed: "Fallido",
  failedToLoad: "Fallo en la carga.",
  feedback: "Comentarios",
  feelFreeToContactSocashless: "Por favor, no dudes en contactar con nosotros en SoCashless.",
  filters: "Filtros",
  firstName: "Nombre",
  fixedAmount: "Cantidad fija",
  fixedAmountRange: "La cantidad fija debe ser entre 1-9,999,999",
  footerSection: "Sección de pie de página",
  forApproval: "Para aprobación",
  forProperReportingAndTo:
    "Para obtener informes adecuados y mantener su tablero actualizado, ejecute el Fin del día diariamente para evitar la pérdida de datos.",
  forProperReportingWithYourMews:
    "Para obtener informes adecuados con su cuenta de MEWS, asegúrese de que la ventana de historial editable de contabilidad esté configurada en 7 días. Ejecute el Fin del Día diariamente para evitar la pérdida de datos.",
  forceBanned: "Detalles de salida forzada y bloqueo",
  forceCheckOutBy: "Salida forzada por",
  forceCheckout: "Forzar la salida",
  forceCheckoutDetails: "Detalles de la salida forzada",
  forceCheckoutName: "¿Forzar la salida {0}?",
  forcedCheckedOutBy: "Salida forzada por",
  formatting: "Formateando",
  freeCredits: "Créditos gratuitos",
  freeCreditsAreCreditsThatAreFreeOfCharge:
    "Los créditos gratuitos son créditos que no tienen ningún coste. Estos créditos son",
  freeCreditsHoverTooltip:
    "Los créditos gratuitos no son reembolsables y se priorizarán y utilizarán en primer lugar tras los pagos.",
  freeCreditsIssued: "Créditos gratuitos emitidos",
  freeCreditsLiabilityAccount: "Cuenta de pasivo de créditos gratuitos",
  freeCreditsLiabilityAccountMessage:
    "Coste de los créditos gratuitos emitidos a los huéspedes una vez utilizados.",
  freeCreditsLiabilityAccountPlaceholder: "[xxxx] - Responsabilidad/créditos gratuitos",
  freeCreditsRemoved: "Créditos gratuitos eliminados",
  freeTrial: "¡30 días de prueba gratuita!",
  frontOfficeRoleAppDesc:
    "Este rol no tiene roles relacionados con la aplicación y no podría iniciar sesión en el dispositivo.",
  frontOfficeRoleDashboardDesc:
    "Permite el acceso a la información, las reservas, los invitados, las transacciones, los informes, los dispositivos y las etiquetas de prohibición del panel.",
  fullPay: "Pago Completo",
  full: "Completo",
  gender: "Género",
  general: "General",
  generalSettings: "Configuración general",
  generatingReport: "Generando informe...",
  getFreeCredit: "Obtener crédito gratuito",
  getNotifications: "Recibir notificaciones",
  getStarted: "Empezar",
  glass: "cristal",
  glossary: "Glosario",
  goToXDashboard: "Ir al panel de control de {0}",
  grossProfit: "Beneficio bruto",
  guest: "Huésped",
  guestCheckedOutAndBanned: "Huéspedes con etiqueta de salida y bloqueados.",
  guestDetails: "Datos del huésped",
  guestInfoNotYetSync: "La información del huésped aún no está sincronizada",
  guestInformationYouCollect: "Información del huésped recogida durante la entrada.",
  guestList: "Lista de huéspedes",
  guestName: "Nombre del huésped",
  guestNameAndOrTagId: "Nombre del huésped y/o ID de la etiqueta",
  guestOrTagStatus: "Estado del huésped o etiqueta",
  guestProfile: "Perfil de huésped",
  guestProfileDeleted: "Perfil de huésped eliminado.",
  guestProfileDescriptionPlaceholder:
    'P. ej., "Huéspedes que se registran en la zona de restaurantes".',
  guestProfileList: "Lista de perfiles de huésped",
  guestProfileName: "Nombre del perfil de huésped",
  guestProfileNameCreate: 'Perfil de huésped "{0}" creado.',
  guestProfileNamePlaceholder: 'P. ej., "Huéspedes de la zona de restaurantes".',
  guestProfiles: "Perfiles de huésped",
  guestQuestions: "Preguntas de los huéspedes",
  guestSince: "Huésped desde {0}",
  guestSpecialRequest: "Solicitudes especiales del huésped",
  guestSpecialRequests: "Solicitudes especiales de huéspedes",
  guestTap: "Tap de huésped",
  guestWithColonSymbol: "Huésped:",
  guests: "Huéspedes",
  guestsCheckedIn: "Huéspedes registrados",
  guestsNewBalance: "Saldo nuevo del huésped",
  guestsPreviousBalance: "Saldo anterior del huésped",
  guestsPreviousBalanceTotalPaidAndNewBalance:
    "Saldo anterior del huésped, total pagado y nuevo saldo",
  guestsStatus: "Estado del huésped",
  headOfBooking: "Huésped principal de la reserva",
  headOfReservation: "Huésped principal de la reserva",
  headerSection: "Sección de encabezado",
  hello: "Hola",
  helpCenter: "Centro de ayuda",
  hiHeresWhatsHappening: "Hola {0}, bienvenido a tu panel.",
  hiName: "Hola, {0}",
  goodMorning: "Buenos días, {0}",
  goodAfternoon: "Buenas tardes, {0}",
  goodEvening: "Buenas noches, {0}",
  heresHowVenueIsPerforming: "Así es como se está desempeñando {0}.",
  hidden: "Oculto",
  hide: "Ocultar",
  hideDetails: "Ocultar detalles",
  hideInPos: "Ocultar en POS",
  hideVariant: "Ocultar variante",
  highDenominations: "Altas Denominaciones",
  holdingAccountForToppedUpItems:
    "Cuenta de reserva de todos los créditos que se recargan en una etiqueta antes de la venta",
  hour: "hora",
  hours: "horas",
  id: "ID",
  ifYouLeaveThisPage:
    "Si abandonas esta página, todos los cambios no guardados se perderán. ¿Seguro que quieres descartar los cambios?",
  ifYoudLikeToJustStopSellingProduct:
    'Si quieres dejar de vender un producto en tu POS, simplemente deshabilítalo desactivando "Vender en POS".',
  imageTypeSize: "JPG GIF o PNG. Tamaño máx. de 1MB",
  impItem: "Importación de artículos",
  impItemMaxSize: "Tamaño máximo 25 MB",
  impItemModalNote1:
    "Para el artículo/producto de suministro que ya existía en el inventario, la importación aumentará la cantidad de ese artículo de suministro en el inventario.",
  impItemModalNote2:
    "Para el artículo de suministro/producto que no existe en el inventario, haga clic en confirmar para generar un nuevo SKU en el inventario.",
  impItemsErr1: "No se puede encontrar la ubicación {0}",
  impItemsErr2: "Medida {0} no encontrada",
  impItemsErr3: "Formato de datos de la hoja {0} {1} incorrecto",
  impItemsErr4: "Hay una diferencia de precio para el artículo de suministro {0} + Medida {1}",
  impItemsErr5: "La hoja {0} no debe exceder las 200 filas",
  impItemsErr6: "Categoría no encontrada",
  impItemsErr7: "Hay una diferencia de precio para el Producto {0} + Medida {1}",
  impItemsPlsRecheck:
    "Vuelva a verificar los datos en la importación de archivos y cárguelos nuevamente.",
  import: "Importar",
  importSupplyItems: "Importar artículos de suministros",
  importSupplyItemsCreateWholeProducts:
    "Importe artículos de suministro y cree productos completos",
  importSupplyItemsErr:
    "Los nombres de las ubicaciones no coinciden con las ubicaciones existentes en el lugar. Por favor vuelva a verificar",
  in: "en",
  inProgress: "En progreso",
  inStock: "En Stock",
  inactive: "Inactivo",
  include: "Incluir",
  indeterminate: "indeterminado",
  information: "Información",
  informationToCollect: "Información a recoger en el registro de huéspedes.",
  integrateDesc: "Integración con potentes sistemas de gestión de propiedades y mucho más.",
  integrationSettingDesc:
    "Conéctate con otras apps de negocios y productividad para aumentar tu negocio.",
  integrationSettings: "Configuración de integración",
  integrations: "Integraciones",
  invalidFileType: "Tipo de archivo no válido. Los tipos de archivo permitidos son JPG o PNG.",
  invalidOptions: "Opción(es) no válida(s).",
  invalidTimeRange: "Rango de tiempo no válido",
  invalidToken: "Token no válido",
  inventory: "Inventario",
  inventoryAccount: "Cuenta de inventario",
  inventoryAccountMessage:
    "Para los artículos de suministro adquiridos e inventario antes de la venta.",
  inventoryAccountPlaceholder: "Cuenta de pérdidas/ganancias del inventario",
  inventoryGainLossAccount:
    "Para las discrepancias en las existencias, ajustes de existencias, etc.",
  inventoryGainLossAccountMessage: "Gestión del inventario",
  inventoryGainLossAccountPlaceholder: "Movimiento del inventario",
  inventoryManagement: "Página de movimiento de inventario",
  inventoryMovement: "Informe del inventario",
  inventoryMovementPage: "Valor del inventario",
  inventoryReport: "Reporte de Inventario",
  inventoryValue: "[xxxx] - Ganancia/pérdida en la venta de inventario",
  invitationHasBeenSentTo: "Se ha enviado una invitación a {0}.",
  inviteNewStaff: "Invitar nuevo personal",
  inviteYourVenueStaff: "Invita al personal del espacio, gestiona su rol y acceso en tu POS",
  isAreserveWord: "es una palabra de reserva.",
  issuanceLimit: "Límite de emisión",
  issue: "Emitir",
  issueFreeCredits: "Emitir créditos gratuitos",
  issuedBy: "Emitido por",
  issuedOn: "Emitido en",
  item: "Artículo",
  itemName: "Nombre del artículo",
  itemTax: "Impuesto sobre el artículo",
  items: "Artículos",
  itemsSold: "Artículos vendidos",
  justNow: "Ahora mismo",
  lastIssuedTo: "Último emitido a",
  lastModifiedBy: "Última modificación realizada por",
  lastModifiedOn: "Última modificación",
  lastName: "Apellidos",
  lastPurchasedProduct: "Último producto comprado",
  lastSync: "Última sinc.",
  lastSynced: "Última sincronización {0}",
  lastVisitedLocation: "Último lugar visitado",
  learnMore: "Más información",
  legalBusinessName: "Nombre legal de la empresa",
  letsGetStarted: "Empezar",
  liability: "Responsabilidad",
  limit: "Límite",
  limitVoucherPerPerson: "Límite de vale emitido por persona",
  linkAccountingItem: "Vincular partida contable",
  linkMiniWeb: "Enlace Mini Web",
  linkWithMewsAccountingItems: "Conectar con artículos contables de MEWS",
  loading: "Cargando...",
  location: "Ubicación",
  locationDesignation: "Ubicación designada",
  locationName: "Nombre de la ubicación",
  locationNameAlreadyExist: "Esta ubicación ya existe. Elige un nombre diferente.",
  locationNameCreated: 'Ubicación "{0}" creada.',
  locationNameDeleted: 'Ubicación "{0}" eliminada.',
  locationNameUpdated: 'Ubicación "{0}" actualizada.',
  locationVoucherRedeemed: "Elija la(s) ubicación(es) donde se canjea este vale.",
  locations: "Ubicaciones",
  locationsList: "Lista de puntos de venta",
  logIn: "Iniciar sesión",
  login: "Iniciar sesión",
  loginHasEnded: "Tu sesión ha ha finalizado. Por favor, inicia sesión de nuevo.",
  loginSessionEnded: "Sesión de inicio de sesión finalizada",
  logout: "Cerrar sesión",
  looksLikeAlreadyInSystem: "Parece que ya estás en nuestro sistema",
  looksLikeYouEncounteredSomething:
    "Parece que ha habido un error. Hacemos un seguimiento de estos errores automáticamente. Mientras tanto, actualiza la sesión.",
  looksLikeYouHaveNoLocationYet: "Parece que aún no dispones de ninguna ubicación.",
  lostTag: "Etiqueta perdida",
  lostTags: "Etiquetas perdidas",
  lowDenominations: "Bajas Denominaciones",
  lowOrOutOfStock: "Poco o fuera de stock",
  lowParLevel: "Nivel PAR bajo",
  lowerCaseNoneRefundable: "no reembolsable",
  lowerCaseTopUpCredits: "créditos de recarga",
  mailingList: "Lista de correo",
  manageAccountNotificationStockLevel:
    "Gestionar cuentas para notificar cuando un artículo caiga al nivel de alerta.",
  manageAndAssignQuestions:
    "Gestionar y asignar preguntas en la entrada, créditos gratuitos y vales a los diferentes perfiles de huésped.",
  manageBusinessInfo: "Gestionar información de negocio",
  manageBusinessInformation: "Gestionar información de negocio",
  manageEmailNotif: "Gestionar las notificaciones enviadas por e-mail a mi cuenta y al personal.",
  manageHowVenueTax:
    "Gestiona cómo se cobran los impuestos en tu espacio dependiendo de la región. Consulta con un experto en impuestos para entender cuáles son tus obligaciones fiscales.",
  manageImportantDetailsSettings:
    "Gestiona los detalles y reglas importantes de tu espacio, como la configuración de tu cuenta, del espacio, de los pagos y créditos y de la entrada.",
  manageInventory: "Gestionar inventario",
  manageInventoryAndProducts: "Gestionar el inventario y los productos de este conjunto.",
  manageInventoryAndSupply:
    "Gestionar el inventario y los artículos de suministro de este producto.",
  manageLocationTable: "Administrar la disposición de las mesas y los asientos de esta ubicación",
  manageNotifcations: "Gestionar las alertas y notificaciones por e-mail enviadas al personal.",
  managePlacesYouStock:
    "Gestionar los lugares donde se almacena el inventario y se venden los productos.",
  manageReceipts: "Gestionar la apariencia e información de tus recibos.",
  manageSupplyItems: "Gestionar los artículos de suministro",
  manageThePosDevicesVenue: "Gestionar los dispositivos POS registrados y en uso en tu ubicación",
  manageTheStocksPerLocation:
    "Gestionar las existencias de este artículo de suministro por ubicación.",
  manageToppedUpCredits: "Gestionar los créditos recargados, gratuitos, de pospoago y caducados.",
  manageVariants: "Gestionar variantes",
  manageYourAccountsSales:
    "Gestiona tus cuentas en relación con las ventas, coste de los bienes, impuestos sobre los productos o descuentos.",
  manageYourStaffProfileDescription:
    "Gestiona el personal, sus funciones, designaciones y el perfil de personal al que pertenecen.",
  manageYourVenueSetting:
    "Gestiona la configuración de tu espacio, como los impuestos y la moneda.",
  manageYourVenueSubscription:
    "Gestiona la suscripción de tu espacio, la información de facturación y las facturas.",
  manageYourVenueTax: "Añade y gestiona el cobro de impuestos de tu espacio.",
  manager: "Administrador",
  managerAuthorization: "Autorización del manager",
  managerRoleDesc: "Acceso completo tanto al sitio web en línea como a la aplicación.",
  mapAndManageAccounts:
    "Mapea y administra tus cuentas predeterminadas para cada proceso de negocio de SoCashlessVENUE.",
  mapAndManageAccountsLink: "Asigna y gestiona tus cuentas en {0} para una contabilidad adecuada",
  mapYourAccounts: "Mapea tus cuentas para activos de inventario, gastos de discrepancia, etc.",
  margin: "Margen",
  markUp: "Margen de beneficios",
  maximumLengthCharacters: "Máximo de {0} caracteres",
  maximumValueAllowed: "El valor máximo permitido es de 20 000 000",
  maximumValueIs: "El valor máximo es ",
  measurement: "Medida",
  measurements: "Medidas",
  mediumDenominations: "Medianas Denominaciones",
  milk: "leche",
  minOfNCharacters: "Mínimo de {0} caracteres",
  minimum: "Mínimo",
  minimumCharactersAllowed: "Mínimo de {0} caracteres permitidos",
  minimumOf: "Se requiere un mínimo de 2 elementos.",
  minimumValueIs: "El valor mínimo es ",
  minute: "minuto",
  minutes: "minutos",
  missedCheckIn: "Registro de entrada no realizado",
  missedCheckOut: "Registro de salida no realizado",
  mixed: "Mixto",
  mobileNumber: "Número de móvil",
  month: "mes",
  months: "meses",
  monthsAfterCheckout: "meses después de la salida",
  mostPurchasedProduct: "Producto más comprado",
  mostVisitedLocation: "Lugar más visitado",
  movement: "Movimiento",
  nOptions: "{0} opciones",
  nTon: "{0} a {1}",
  name: "Nombre",
  nameAdded: "{0} añadido.",
  nameYourProduct: "Nombra tu producto",
  nameYourProductSet: "Nombra el conjunto de productos",
  nameYourSupplyItem: "Nombra el artículo de suministro",
  nationality: "Nacionalidad",
  needAdditionalSupportContact: "Si necesitas ayuda adicional, contacta con {0}.",
  needHelp: "¿Necesitas ayuda?",
  netWeightN: "Peso neto {0}",
  new: "Nuevo",
  newBalance: "Nuevo balance",
  newGuests: "Nuevos huéspedes",
  newInviteLink: 'Se ha enviado un nuevo enlace de invitación a "{0}"',
  newPassWord: "Nueva contraseña",
  newProduct: "Nuevo producto",
  newProductSet: "Nuevo conjunto de productos",
  newQty: "Nueva cantidad",
  newQuantity: "Nueva cantidad",
  newToSocashless: "¿Eres nuevo en SoCashless?",
  no: "No",
  noAccountsAvailable: "Aún no hay ninguna cuenta",
  noAccountsYet: "No hay ninguna cuenta",
  noAvailableCategories: "No hay categorías disponibles",
  noAvailableGuestProfile: "Perfil de huésped no disponible",
  noAvailableLocations: "Puntos de venta no disponibles",
  noAvailableLocationsYet: "Aún no hay puntos de venta disponibles.",
  noAvailablePaymentMethodYet: "Aún no hay un método de pago disponible.",
  noAvailableStaff: "No hay personal disponible",
  noBannedTagsYet: "Aún no hay etiquetas bloqueadas.",
  noBookingsYet: "No hay reservas.",
  noCheckInsInDateRange: "No hay registros para este intervalo de fechas.",
  noData: "Sin datos",
  noDeviceAvailable: "No hay dispositivos disponibles",
  noDevicesFound: "No se han encontrado dispositivos",
  noEndDate: "Sin fecha de finalización",
  noLocation: "Sin ubicación",
  noLocationAvailable: "Sin ubicación disponible",
  noNotesFound: "No se han encontrado notas",
  noOfGuests: "Nº de huéspedes",
  noOfNights: "Nº de noches",
  noOfTables: "# de mesas",
  noProductsAvailable: "No hay productos disponibles",
  noProductsSelected: "Aún no se ha seleccionado ningún producto.",
  noRecordsOf: "Sin registros de",
  noRemainingBalance: "Sin saldo restante",
  noReportsFound: "No se han encontrado informes.",
  noResultInSearch: "No hemos encontrado ningún resultado para tu búsqueda.",
  noResults: "No hay resultados",
  noResultsFound: "No se han encontrado resultados",
  noResultsMatching: "No hay resultados que coincidan",
  noResultsMatchingX: 'No hay resultados que coincidan con "{0}"',
  noReturnCreditsInDateRange: "No hay devolución de créditos para este rango de fechas.",
  noSalesInDateRange: "No hay ventas en este rango de fechas.",
  noSearchResultsForName: "No hay resultados de búsqueda para {0}.",
  noStocks: "Sin stock",
  noTagUid: "No hay etiqueta UID",
  noTagYet: "Sin manilla aún",
  noTagsFound: "No se han encontrado etiquetas.",
  noVoucherAvailable: "No hay vales disponibles",
  noVoucherMovement: "Ningún movimiento de vales.",
  noVouchersSelectedYet: "No se ha seleccionado ningún vale.",
  nonRefundable: "No reembolsable",
  notCheckedIn: "No registrado",
  notSellingOnPos: "Sin venta en POS",
  note: "notas",
  notePreviousTransaction:
    "Nota: Tus transacciones anteriores realizadas con estos productos se conservarán.",
  noteTransactionStaff:
    "Nota: Tus transacciones anteriores realizadas con este personal se conservarán.",
  notedByOn: "Anotado por {0} en {1}",
  notes: "Notas",
  notificationSettings: "Configuración de notificaciones",
  notifications: "Notificaciones",
  nthGuestWhoUseThisTag: "{0} huéspedes que han utilizado esta etiqueta.",
  nthStaffWhoUsedThisTag: "{0} personal que ha utilizado esta etiqueta.",
  nthUse: "{0} uso",
  numberAbbr: "N.º",
  numberOfGuests: "# de huéspedes",
  numberOfNights: "# de noches",
  odooDescription: "Suite ERP abierta que abarca contabilidad, inventario y compras.",
  offline: "Desconectado.",
  ok: "Entendido",
  okay: "Entendido",
  onPos: "En POS",
  onceYouBanATag:
    "Una vez que bloquees una etiqueta ya no podrá ser utilizada para realizar transacciones dentro de tu espacio.",
  onceYouBlockATag:
    "Una vez que bloquees una etiqueta ya no podrá ser utilizada para realizar transacciones dentro de tu espacio.",
  onceYouCompleteStocktake:
    "Una vez que completes un inventario, todas las cantidades reales de los artículos de suministro se ajustarán de acuerdo con este. Esta acción no se puede deshacer.",
  open: "Abrir",
  openReceiptPreview: "Abrir vista previa del recibo",
  openWindow: "Abrir ventana de puntos de venta",
  openingBalance: "Saldo de apertura",
  optionNameAlreadyExists: "Este nombre ya existe",
  options: "Opciones",
  orNo: "OR#",
  orderQty: "Cant. de pedido",
  orderYourNFCTags: "Ordenar tus manillas NFC",
  original: "Original",
  other: "Otro",
  others: "Otros",
  overTime: "En el tiempo",
  overview: "Resumen",
  pairedTagOnCheckin: "Etiqueta emparejada en la entrada",
  pairedTags: "Etiquetas emparejadas",
  parLevel: "Nivel par",
  partiallyConnected: "Parcialmente conectado",
  password: "Contraseña",
  passwordDoesNotMatch: "Las contraseñas introducidas no coinciden",
  passwordIncorrect: "La contraseña que has introducido no es correcta.",
  passwordsDoNotMatch: "Las contraseñas no coinciden",
  paymentAndCreditSettings: "Pago y configuración de créditos",
  paymentGateway: "Pasarela de pago",
  paymentGateways: "Pasarelas de pago",
  paymentMethod: "Método de pago",
  paymentMethodAddedName: 'Método de pago "{0}" añadido.',
  paymentMethodAlreadyExist: "El método de pago ya existe",
  paymentMethodName: "Nombre del método de pago",
  paymentMethods: "Métodos de pago",
  paymentMethodsDescription: "Crea y gestiona los métodos de pago aceptados en tu espacio.",
  paymentMethodsSettings: "Configuración del método de pago",
  paymentMethodsYouAccept: "Métodos de pago aceptados en tu espacio.",
  paymentOrder: "Orden de pago",
  paymentStatus: "Estado del pago",
  paymentType: "Tipo de pago",
  peakHours: "Horas pico",
  pending: "Pendiente",
  permBasicVenueInformation: "Información básica del establecimiento",
  permBookingsAndGuestDetails: "Reservas y datos de huéspedes",
  permCustomPaymentMethod: "Método de pago personalizado",
  permHouseAccount: "Cuenta de la casa",
  permSaleTransactions: "Transacciones de venta",
  perPage: "{0} por página",
  percentage: "Porcentaje",
  percentageBetween: "El porcentaje debe ser entre 1-100",
  permitNumberWithColonSymbol: "Número de permiso:",
  phone: "Teléfono",
  pleaseCheckYourNetwork: "Por favor, comprueba tu red para actualizar los datos de tu espacio.",
  pleaseChooseLocation: "Por favor elige ubicación",
  pleaseConnectToAnAccounting:
    "Por favor, conéctate a una cuenta de integración para gestionar tu gráfico de cuentas",
  pleaseCreateLocation:
    "Por favor, crea al menos 1 ubicación para asignar las existencias de este artículo de suministro.",
  pleaseCreateYourChartOfAccounts:
    "Por favor, crea tu gráfico de cuentas en la categoría de contabilidad en tu panel de control MEWS.",
  pleaseEnsureLocation:
    "Por favor, asegúrate de que una ubicación no tiene transacciones en curso antes de iniciar el recuento de existencias.",
  pleaseSelectAtLeastOneRole: "Seleccione al menos un rol.",
  pleaseSelectLocation: "Por favor, selecciona una ubicación",
  pleaseSelectStockUnit: "Por favor, selecciona la unidad de stock",
  pointOfSale: "Punto de venta",
  posDevices: "Dispositivos de punto de venta",
  posOnly: "POS",
  posProvider: "Proveedor POS",
  postPaidCreditsIsTheAmount:
    "Los créditos de pospago son la cantidad que un huésped puede utilizar cuando su saldo llega a cero. Cuando un cliente tiene un saldo de créditos de pospago, el importe debe liquidarse y pagarse a través de una recarga o en el momento de la salida.",
  postPaidCreditsUsed: "Créditos de pospago utilizados",
  postpaidCreditLimit: "Límite de crédito de pospago",
  postpaidCredits: "Créditos de pospago",
  postpaidCreditsLiabilityAccount: "Cuenta de pasivo de créditos de pospago",
  postpaidCreditsLiabilityAccountMessage:
    "Créditos utilizados cuando un huésped llega a un saldo de cero. Se pagan a través de una recarga en el momento de la salida.",
  postpaidCreditsLiabilityAccountPlaceholder: "[xxxx] - Activo/Créditos de pospago",
  postpaidCreditsUsed: "Créditos pospago utilizados",
  postpaidCreditsUsedCanOnlyBeReplenished:
    "Los créditos de pospago utilizados sólo pueden reponerse y pagarse a través de una recarga o en el momento de la salida.",
  productHasVariantsEditPriceInDetail: "Este producto tiene variantes, vaya al detalle del producto para editar el precio",
  propertyManagementSystems: "Sistemas de gestión hotelera",
  refundClaimEndDate: "Fecha de fin de solicitud de reembolso",
  refundClaimStartDate: "Fecha de inicio de solicitud de reembolso",
  registeredLabel: "Registrado",
  resetToAllDay: "Restablecer a todo el día",
  returnCreditsOutlet: "Punto de venta de devolución de créditos",
  revenueAccountAssigned: "Cuenta de ingresos asignada",
  saleOutlet: "Punto de venta",
  salesByPaymentType: "Ventas por tipo de pago",
  salesOutlet: "Punto de venta de ventas",
  saturday: "Sábado",
  saveQuestions: "Guardar preguntas",
  selectCreditsKeptOutlet: "Seleccione el punto de venta de créditos retenidos",
  selectCreditsReceivedOutlet: "Seleccione el punto de venta de créditos recibidos",
  selectedRefundType: "Seleccione el tipo de reembolso",
  selectReturnCreditsOutlet: "Seleccione el punto de venta de devolución de créditos",
  selectSalesOutlet: "Seleccione el punto de venta de ventas",
  selectService: "Seleccione el servicio",
  selectTimezone: "Seleccione la zona horaria",
  selectTopUpOutlet: "Seleccione el punto de venta de recargas",
  service: "Servicio",
  setRevenueAccount: "Establecer cuenta de ingresos",
  setTime: "Establecer hora",
  sevenRoomsDescription: "Plataforma de experiencia del huésped y reservas para operadores de hospitalidad.",
  shiftHasUnsyncedTransactions: "Este turno aún tiene transacciones sin sincronizar. Revise el dispositivo de este turno y vaya a la pantalla \"Push Venue Data\" para sincronizar.",
  showing: "Mostrando:",
  siigoDescription: "Contabilidad en línea con facturación conforme a la DIAN para Colombia.",
  snAbbr: "N.º",
  socashlessConnect: "SoCashlessCONNECT",
  socashlessLogo: "Logotipo de SoCashless",
  socashless: "SoCashless",
  powerYourVenue: "Impulsa tu espacio con las integraciones.",
  preloadedVouchers: "Vales precargados",
  preparingReport: "Preparación de informes",
  previousBalance: "Saldo anterior",
  price: "Precio",
  pricePerOrderQty: "Precio por cant. de pedido",
  pricing: "Precio",
  pricingAndTaxes: "Precio e impuestos",
  printableItems: "Artículos imprimibles",
  printableItemsSelect: "Elige qué productos se imprimen en este perfil de impresora.",
  printerLocationsDesc:
    "Elige la(s) ubicación(es) donde se puede utilizar este perfil de impresora.",
  printerProfile: "Perfil de la impresora",
  printerProfileCreated: 'Perfil de impresora {0}" creado.',
  printerProfileDeleted: "Perfil de impresora eliminado",
  printerProfileName: "Nombre del perfil de impresora",
  printerProfileNameAlreadyExists: "Este nombre de perfil de impresora ya existe.",
  printerProfileUpdated: 'Perfil de impresora "{0}" actualizado.',
  printerProfiles: "Perfiles de impresora",
  printers: "Impresoras",
  prioritizedAndUsedFirst: "priorizadas y utilizadas en primer lugar tras los pagos.",
  privacy: "Privacidad",
  privacyPolicy: "política de privacidad",
  privacyPolicy2: "Política de privacidad",
  proceed: "Proceder",
  proceedToCheckout: "Proceder a la compra",
  processingTransactions: "Procesando transacciones...",
  product: "Producto",
  productCategories: "Categorías de producto",
  productCategory: "Categoría de producto",
  productCount: "Recuento de productos",
  productDeleted: 'Producto "{0}" eliminado.',
  productList: "Lista de productos",
  productName: "Nombre del producto",
  productRedeemed: "Producto usado",
  productRemovedFromInventory: "{0} producto retirado del inventario.",
  productSet: "Conjunto de productos",
  productSetDeleted: 'Conjunto de productos "{0}" eliminado.',
  productSetName: "Nombre del conjunto de productos",
  productUpdated: "{0} producto actualizado.",
  products: "Productos",
  productsArePartOfComposite:
    "Estos productos forman parte de otros productos compuestos. Para eliminarlos, quítalos primero de los productos compuestos o elimínalos {0} de los productos compuestos.",
  productsAreSupplyItemsAre:
    "{0} son los artículos que vendes en tu espacio. {1} son los artículos que utilizas para construir tus productos. Los artículos de suministro se gestionan en tu {2}.",
  productsCanBeRedeemed: "Elige qué productos de tu inventario se pueden canjear con este vale.",
  productsDeleted: "{0} productos eliminados.",
  productsDoesNotExist:
    "Los productos que quieres añadir deben existir en todas las puntos de venta.",
  productsForDeletion:
    "{0} producto(s) con esta ubicación también se pueden eliminar. Esta acción no se puede deshacer.",
  productsRemovedFromInventory: "{0} productos eliminados del inventario.",
  productsToBeDeleted: "Productos a eliminar",
  productsUpdated: "{0} productos actualizados.",
  productsVSupplyItems: "Productos vs. artículos de suministro",
  productsVariants: "Productos / variantes",
  productsWithNoCategory: "Productos sin categoría aún",
  profile: "Perfil",
  profileDiscount: "Descuento del perfil",
  profileDiscountDescription:
    "Elige el descuento porcentual que se aplica al gasto total de este huésped",
  profileDiscountRange: "El porcentaje debe estar entre 1-100",
  profileName: "Nombre del perfil",
  profileNameAlreadyExists:
    "El nombre del perfil ya existe, por favor introduzca un nombre diferente.",
  propertyManagementSystem: "Sistema de gestión de propiedades",
  propertyManagementSystemExample: "Sistemas como MEWS e Cloudbeds",
  purchasingAndInventory: "Compras e inventario",
  qty: "Cnt.",
  quantity: "Cantidad",
  quantitySupplyItems: "La cantidad de artículos de suministro utilizados para este producto.",
  question: "Pregunta",
  questionAddedName: 'Pregunta "{0}" añadida.',
  questionAlreadyExist: "La pregunta ya existe.",
  questionDeleted: 'Pregunta "{0}" eliminada.',
  questionDescription:
    "Información a recoger en el registro de huéspedes. Utiliza estas preguntas asignándolas a tu {0}.",
  questionSettings: "Configuración de preguntas",
  questions: "Preguntas",
  radioButton: "Botón de radio",
  reachedReorderPoint: "Punto de reorden alcanzado",
  readyForDownload: "listos para descargar",
  reallyUnbanTag: "¿Seguro que quieres desbloquear esta etiqueta?",
  reallyUnbanThisTagDescription:
    "El desbloqueo de esta etiqueta se efectuará la próxima vez que se sincronicen y actualicen tus dispositivos (normalmente cada 5 minutos si estás conectado a Internet). Para que estos cambios se reflejen inmediatamente, sincroniza y actualiza tus dispositivos una vez que hayas desbloqueado esta etiqueta.",
  reason: "Razón",
  reasonsForStay: "Motivo de permanencia",
  receiptFormatting: "Formato del recibo",
  receiptNumber: "Número de recibo",
  receiptSettings: "Configuración de recibo",
  receipts: "Recibos",
  recentTransactions: "Transacciones recientes",
  reconnect: "Volver a conectar",
  redeem: "Canjear",
  redeemableProducts: "Productos canjeables",
  redeemed: "Canjeado",
  refreshingThisPage: "Actualizar esta página",
  refundedCredits: "Créditos reembolsados",
  registerGuests: "Registrar huéspedes",
  registerGuestsRoleAppDesc: "Este rol no tiene acceso al sitio web.",
  registerGuestsRoleDashboardDesc:
    "Permite el acceso al Check-in y Check-out de invitados de la aplicación.",
  registerInfo: "Información de registro",
  registerReports: "Informes de registro",
  registerReportsPage: "Página de información de registro",
  registerStaff: "Registrar personal",
  registeredBusinessInformation: "Información de la empresa registrada",
  remove: "Eliminar",
  removeFreeCredits: "Eliminar créditos gratuitos",
  removeFromList: "Eliminar de la lista",
  removeNameAsYourStaff: "¿Quitar {0} del personal?",
  removeStocks: "¿Quitar existencias?",
  removeStocksConfirm: "Eliminar existencias",
  removeStocksDetails: "¿Seguro que quieres eliminar {0} {1} en existencias de {2} en {3}?",
  removeThisAccount: "¿Eliminar esta cuenta?",
  removeThisSupplyItem:
    "Elimina este artículo de suministro de los productos antes de eliminar este artículo.",
  removeVariant: "Eliminar variante",
  removeVariantFirstFromProduct: "Eliminar antes esta variante del producto",
  removedStock: "Eliminar stock",
  reorderPoint: "Punto de pedido",
  reorderPointReached: "Punto de pedido alcanzado",
  reorderStocks: "Reordenar existencias",
  report: "Informe",
  reportAProblem: "Reportar un problema",
  reports: "Informes",
  reportsFailedToLoad: "Fallo al cargar los informes.",
  reportsInfoPage: "Página de información de informes",
  requireManagerAuthorization:
    "Se requiere la autorización del mánager al reclamar este descuento.",
  requireManagerAuthorizationVoucher:
    "Requerir autorización del gerente al momento de emitir este comprobante.",
  required: "Requerido",
  resendInvite: "¿Reenviar invitación?",
  resetExpiration: "Restablecer caducidad",
  resetTheExpirationPeriod:
    "Restablece el período de caducidad una vez que el huésped complete una transacción sin registrarse.",
  restrictUseOfTags: "Restringe el uso de ciertas etiquetas en tu espacio.",
  retailPrice: "Precio de venta al público",
  retailPriceMustNotBeNegative: "El precio de venta al público no debe ser negativo",
  retryReloadingChart: "Reintentar cargar gráfico",
  returnCredits: "Devolver créditos",
  returnCreditsRoleAppDesc: "Este rol no tiene acceso al Panel de Control de Venue en línea.",
  returnedTags: "Etiquetas devueltas",
  returnedVoucher: "Vale devueltos",
  returningGuests: "Huéspedes recurrentes",
  revenue: "Ingresos",
  revenueAccount: "Cuenta de ingresos",
  revenueAccountPlaceholder: "[xxxx] - Ingresos/Ventas FOC",
  reviewYourDailyVenueActivity: "Revisa la actividad diaria de tu espacio.",
  revokeInvite: "Revocar invitación",
  revokeThisInvite: "¿Revocar esta invitación?",
  roadMap: "Hoja de ruta",
  role: "Rol",
  roleAndDesignation: "Función y designación",
  roles: "Roles",
  rooms: "Salas",
  runEndOfDay: "Ejecutar final del día",
  sale: "Venta",
  saleDiscounts: "Ingresos/ Descuentos en ventas",
  saleFoc: "Ingresos/ Ventas FOC",
  saleReturn: "Devolución de venta",
  sales: "Ventas",
  salesDiscounts: "Descuentos en ventas",
  salesDiscountsMessage: "El coste de todos los descuentos aplicados.",
  salesDiscountsPlaceholder: "[xxxx] - Descuento de venta",
  salesFOC: "Ventas FOC",
  salesFOCMessage: "El costo de todos los créditos gratuitos aplicados",
  salesFOCPlaceholder: "[xxxx] - Ingresos/ventas FOC",
  salesInformation: "Información de ventas",
  salesOverTime: "Ventas a lo largo del tiempo",
  salesReport: "Informe de ventas",
  save: "Guardar",
  saveAccountSetting: "Guardar configuración de la cuenta",
  saveCategoryForm: "Guardar formulario de categoría",
  saveCreditSetting: "Guardar configuración de crédito",
  saveDeviceForm: "Guardar formulario de dispositivo",
  saveDiscountForm: "Guardar formulario de descuento",
  saveGeneralSettings: "Guardar configuración general",
  saveLocationForm: "Guardar formulario de ubicación",
  saveNewSupplyItemForm: "Guardar formulario de nuevos suministros",
  savePaymentMethod: "Guardar método de pago",
  savePrinterProfileForm: "Guardar formulario de perfil de impresora",
  saveProduct: "Guardar producto",
  saveProductSet: "Guardar conjunto de productos",
  saveQuestion: "Guardar pregunta",
  saveReceiptSettings: "Guardar configuración de recibos",
  saveStaffForm: "Guardar formulario de personal",
  saveStaffProfileForm: "Guardar formulario de perfil del personal",
  saveTaxSetting: "Guardar configuración de impuestos",
  saveVenueForm: "Guardar formulario del espacio",
  saveVoucherForm: "Guardar formulario de vales",
  saveWristbandKeepingSettings: "Guardar configuración de mantenimiento de pulseras",
  savedChanges: "Guardar cambios",
  scheduleACall: "Programar una llamada",
  search: "Buscar",
  search2: "Buscar...",
  searchBanTags: "Buscar etiquetas bloqueadas por etiqueta UID",
  searchBlockedTags: "Buscar etiquetas bloqueadas por etiqueta UID",
  searchForProducts: "Buscar productos o artículos de suministro",
  searchForStockId: "Buscar ID de existencias...",
  searchForStocktakeId: "Buscar ID de inventario...",
  searchGuestsByNameOrId: "Buscar huéspedes por nombre o ID de etiqueta",
  searchMovementPlaceholder: "Buscar movimientos por nombre de vale, dispositivo, huésped",
  searchProductByKeyOrSku: "Buscar productos por palabra clave o SKU",
  searchProductsByKeyword: "Buscar productos por palabra clave",
  searchProductsIn: "Buscar productos en {0}",
  searchReportsByShiftId: "Buscar informes por id de turno",
  searchResult: "buscar resultado",
  searchResults: "buscar resultados",
  searchSupplyItemBy: "Buscar artículo de suministro por nombre o SKU",
  searchTag: "Buscar etiqueta",
  searchTransactionPlaceholder:
    "Buscar transacciones por nombre de huésped, ID de etiqueta, ubicación, ID de entrada",
  searchVouchers: "Buscar Vales",
  second: "segundo",
  seconds: "segundos",
  selectAType: "Selecciona un tipo",
  selectAccount: "Seleccionar cuenta",
  selectAccountPlaceholder: "Seleccionar cuenta...",
  selectAccountType: "Seleccionar tipo de cuenta",
  selectAndMakeComposition: "Selecciona la marca y la composición de este producto.",
  selectCategoriesOrProducts:
    "Selecciona las categorías o los productos de las ubicaciones elegidas",
  selectCategory: "Seleccionar categoría",
  selectCountry: "Seleccionar país",
  selectDevice: "Seleccionar dispositivo",
  selectGuestProfile: "Seleccionar perfil de huésped",
  selectItemsThisProductMadeOf:
    "Selecciona el/los artículo/s de los que se compone este producto. Establece la cantidad de cada artículo de suministro que se descontará por orden de venta de este producto.",
  selectLocation: "Seleccionar ubicación",
  selectProducts: "Seleccionar productos",
  selectStaff: "Seleccionar personal",
  selectStatus: "Seleccionar estado",
  selectStockLevel: "Seleccionar nivel de stock",
  selectStockUnit: "Seleccionar unidad de stock",
  selectSupplyItem: "Seleccionar artículo de suministro",
  selectTax: "Seleccionar impuesto",
  selectToIncludeCategory: "Selecciona para incluir este producto en una categoría..",
  selectToIncludeProductSetInCategory:
    "Selecciona para incluir este conjunto de producto en una categoría..",
  selectVenue: "Seleccionar espacio",
  selectVouchers: "Seleccionar vales",
  sellOnPos: "Vender en POS",
  sellOnPosRoleAppDesc: "Este rol no tiene acceso al sitio web.",
  sellOnPosRoleDashboardDesc: "Permite el acceso a la Venta POS de la aplicación.",
  selling: "Vendiendo",
  sellingOnPos: "Vendiendo en POS",
  sellingQty: "Cant. de venta",
  serialNumber: "Número de serie",
  serialNumberAbbv: "S/N",
  set: "Configurar",
  setAnAmountToLimitPostPaid:
    "Establecer una cantidad para limitar los créditos pospago permitidos a un huésped.",
  setAsDefaultTax: "Establecer como impuesto por defecto",
  setAsNonRefundable: "Establecer como no reembolsable",
  setCode: "Establecer código",
  setExpirationPeriod: "Establecer periodo de caducidad",
  setUpYourAccount: "Configura tu cuenta",
  setUpYourSoCashlessAccount: "Configura tu cuenta de SoCashless",
  sets: "Config.",
  settings: "Configuración",
  share: "Compartir",
  shareThisLink:
    "Comparte este enlace para abrir {0} en cualquier dispositivo. Copie el enlace y compártelo con tus empleados.",
  shift: "Turno",
  shiftEnd: "Fin del turno",
  shiftId: "ID del turno",
  shiftStart: "Inicio de turno",
  shifts: "Turnos",
  shouldBeANumber: "Debe ser un número.",
  show: "Mostrar",
  showHideColumns: "Mostrar / ocultar columnas",
  showLess: "Mostrar menos",
  showMore: "Mostrar más",
  signIn: "Iniciar sesión",
  signInButton: "Botón de inicio de sesión",
  signUp: "Registrarse",
  siigoSendInvoiceError:
    "Error al enviar la factura. Por favor, haz clic en el número de factura correspondiente para más información.",
  sku: "SKU",
  skuAlreadyExists: "El SKU ya existe.",
  skuStockKeepingUnit: "SKU (Unidad de Mantenimiento de Stock)",
  software: "Software",
  someArePartOfCompositeNote:
    "{0} {1} de abajo no pueden ser eliminados ya que forman parte de otros productos compuestos. Para borrarlos, elimínalos de los productos compuestos o bórralos {2} con los productos compuestos que los llevan.",
  somethingWentWrong: "Algo ha salido mal.",
  somethingWentWrongPlsTryAgain: "Algo salió mal. Por favor inténtalo de nuevo",
  sourceLocation: "Ubicación de origen",
  sourceLocationOriginalQty: "Ubicación de origen cantidad inicial",
  sourceLocationRemainQty: "Ubicación de origen cantidad restante",
  sourceLocationTransferQty: "Cantidad de transferencia de ubicación de origen",
  spend: "Gasto",
  spentOnSales: "Gastado en ventas",
  split: "División",
  splitInfo: "Información de División",
  splitShare: "Parte Dividida",
  paymentMode: "Modo de Pago",
  edited: "Editado",
  staff: "Personal",
  staffCanAccess: "El personal puede acceder a la aplicación POS y realizar acciones.",
  staffList: "Lista del personal",
  staffName: "Nombre del personal",
  staffNameAndOrTagId: "Nombre del personal y/o ID de etiqueta",
  staffNote: "Nota del personal",
  staffPaymentMethodTooltip: "El método de pago que se puede aceptar para los roles Recargar créditos, Vender en POS y Registrar huésped.",
  staffProfile: "Perfil del personal",
  staffProfileDeleted: "Perfil del personal eliminado",
  staffProfileList: "Lista de perfil del personal",
  staffProfileName: "Nombre del perfil del personal",
  staffProfileNameCreated: 'Perfil de personal {0}" creado.',
  staffProfileNamePlaceholder: "Escribe el nombre de este perfil del personal...",
  staffProfiles: "Perfiles del personal",
  staffRemoved: "Personal eliminado.",
  staffTagWithColonSymbol: "Etiqueta del personal:",
  staffWithColonSymbol: "Personal:",
  standard: "Estándar",
  start: "Iniciar sesión",
  startStocktake: "Iniciar inventario",
  startedOn: "Iniciado en",
  status: "Estado",
  staying: "Permanecer",
  stockAdjSupplyItemsTxtConfirm:
    "¿Está seguro de que desea ajustar el stock de los artículos de suministro en {0}",
  stockAdjustment: "Ajuste del stock",
  stockBelowParLevel: "El stock está por debajo del nivel de distribución",
  stockLevelAlerts: "Alertas de nivel de existencias",
  stockLevelNotificationSettings: "Configuración de notificaciones del nivel de existencias",
  stockLevels: "Nivel de existencias",
  stockManager: "Gerente de existencias",
  stockManagerRoleAppDesc:
    "Este rol no tiene roles relacionados con la aplicación y no podría iniciar sesión en el dispositivo.",
  stockManagerRoleDashboardDesc:
    "Permite el acceso al panel del lugar que está limitado solo al inventario de inventario.",
  stockReachedReorderPoint: "El stock ha alcanzado el punto de pedido",
  stockUnit: "Unidad de stock",
  stockVariance: "Variaciónn de stock",
  stockWeightPerN: "Peso del stock por {0}",
  stocks: "Existencias",
  stocktake: "Inventario",
  stocktakeAlreadyExists: "El inventario ya existe",
  stocktakeSaved: "Inventario guardado",
  stocktakeWithId: "Inventario #ST-{0}",
  streetVillage: "Dirección, Ciudad / Localidad",
  subTotal: "Subtotal",
  subscribeAndRegister: "Suscríbete y regístrate ahora para obtener un",
  subscription: "Suscripción",
  success: "Éxito",
  sugar: "azúcar",
  suggested: "Sugerido",
  summary: "Resumen",
  sunday: "Domingo",
  supervisor: "Supervisor",
  supervisorRoleAppDesc: "Este rol tiene acceso a la aplicación y acceso limitado al sitio web.",
  supervisorRoleDashboardDesc:
    "Permite acceso completo a la aplicación y acceso a Reservas, Huéspedes, Transacciones, Informes, Dispositivos y Etiquetas bloqueadas.",
  supplyCost: "Coste del suministro",
  supplyItem: "Artículo de suministro",
  supplyItemAlreadyExists: "El nombre del artículo de suministro ya existe.",
  supplyItemDeleted: "Elemento de suministro eliminado",
  supplyItemNameCreated: 'Elemento de suministro "{0}" creado.',
  stockTransfers: "Transferencias de Existencias",
  supplyItemSummaryPage: "Página de resumen de artículos de suministro",
  supplyItems: "Elementos de suministro",
  supplyTaxes: "Impuestos de suministro",
  supplyUnit: "Unidad de suministro",
  supplyValue: "Costo del suministro",
  syncToMews: "Sincronizar con MEWS",
  table: "Mesa",
  tableManagement: "Gestión de mesas",
  tableManagementAndReservations: "Gestión de mesas y reservas",
  tables: "Mesas",
  tagBanned: "Etiqueta prohibida.",
  tagId: "ID de etiqueta",
  tagIds: "IDs de etiqueta",
  tagInfo: "Información de etiqueta",
  tagUID: "Etiqueta UID",
  tagUnbanned: "Etiqueta autorizada.",
  tags: "Etiquetas",
  tagsIssued: "Etiquetas emitidas",
  tapCount: "Recuento de tap",
  tapStatus: "Estado de tap",
  tax: "Impuesto",
  taxAddedName: 'Impuesto "{0}" añadido.',
  taxAlreadyExists: "El impuesto ya existe.",
  taxEditNote:
    "Nota: Los productos vinculados a este impuesto se actualizarán automáticamente. Esto no afectará a las ventas anteriores.",
  taxEg: 'Por ejemplo, "Impuesto sobre el Valor Añadido".',
  taxIncluded: "Impuesto incluido",
  taxInvoiceNumber: "Factura número de impuesto",
  taxName: "Nombre del impuesto",
  taxNumber: "Número de impuesto",
  taxOnPurchasesAccount: "Impuesto sobre cuenta de compras",
  taxOnPurchasesAccountMessage: "IVA y otros impuestos sobre los pedidos de compra.",
  taxOnPurchasesAccountPlaceholder: "[xxxx] - Responsabilidad/impuesto sobre las compras",
  taxOnSalesLiabilityAccount: "Impuesto sobre la cuenta de pasivo de ventas",
  taxOnSalesLiabilityAccountMessage:
    "Cuenta por defecto para los impuestos cargados para cada producto.",
  taxOnSalesLiabilityAccountPlaceholder: "[xxxx] - Obligación/impuesto sobre las ventas",
  taxPercentageAndValue: "Impuesto ({0}%): {1}",
  taxRate: "Tasa de impuestos",
  taxSettings: "Configuración de impuestos",
  taxes: "Impuestos",
  termsAndConditions: "Términos y condiciones",
  termsInAllowingAccess:
    "Al hacer clic en permitir acceso, autorizas a {0} a utilizar, recibir y almacenar tu información. Por favor, revisa los apartados {2} y {3} de {1}. Puedes pausarlo en cualquier momento en la configuración de integraciones de tu cuenta de SoCashless.",
  termsInSignUp: "Al registrarme, acepto los {0}, {1} y {2} de SoCashless.",
  termsInSoCashlessSignUp: "Al registrarme, acepto los {0} de SoCashless.",
  termsOfService: "condiciones de servicio",
  termsOfUse: "Condiciones de uso",
  textbox: "Cuadro de texto",
  theAmountTheGuestWillPay: "Esta es la cantidad que el huésped pagará por su reserva.",
  theLinkYouAreTryingToAccess: "El enlace al que intentas acceder no es de tu espacio.",
  theLinkYouAreTryingToAccessDoesNotBelongToLocation:
    "El enlace al que intentas acceder no es de tu espacio asignado",
  theShiftAndTransactionDetails:
    "Los detalles del turno y las transacciones se mostrarán aquí una vez que el turno se cierre en el registro.",
  thereIsSomeError: "¡Vaya! Ha ocurrido un error. Por favor,vuelve a intentarlo más tarde.",
  thereNthOtherProducts:
    "{0} {1} otro(s) producto(s) con esta ubicación y otras ubicaciones permanecerán en tu inventario.",
  theseProductsCannotBeDeleted: "Estos productos no pueden ser eliminados.",
  thisAppRequests: "Esta app solicita la siguiente información:",
  thisAppWouldRead: "Esta aplicación requiere la siguiente información:",
  thisArticle: "Este artículo",
  thisEmailIsAlreadyAdded: "Este e-mail ya se ha añadido.",
  thisEmailIsInvalid: "Este e-mail no es válido.",
  thisFieldIsRequired: "Este campo es obligatorio.",
  thisLocationHasTables: "Esta ubicación tiene mesas y arreglos de asientos",
  thisMonth: "Este mes",
  thisProductNameAlreadyExists: "Este nombre de producto ya existe",
  thisProductsHasMultipleVariant:
    "Este producto tiene múltiples opciones como tamaño, color, sabor, etc.",
  thisQuestionIsLinkedToNProfiles: "Esta pregunta está vinculada a {0} perfil(es) de huésped.",
  thisServesAsAnOfficialReceipt: "- ESTO SIRVE COMO RECIBO OFICIAL -",
  thisSkuExists: "Este SKU ya existe",
  thisStaffHasNpLongerAccess:
    "El personal ya no tendrá acceso a {0}. Esta acción no se puede deshacer.",
  thisTagIdIsAlreadyBanned: "Este ID de etiqueta ya está bloqueado.",
  thisVenueFreeTrial: "Este espacio tendrá una prueba gratuita durante los primeros 30 días.",
  thisWeek: "Esta semana",
  thursday: "Jueves",
  ticketId: "ID de ticket",
  time: "Hora",
  timeAccessed: "Hora de acceso",
  timeEnded: "Hora de finalización",
  timeRange: "Intervalo de tiempo",
  timeStarted: "Hora de inicio",
  to: "Para",
  toAddMoreCreditsToATag: "Para añadir más créditos a una etiqueta, los huéspedes pueden",
  toBeCheckedIn: "Para realizar un registro de entrada",
  toBeCheckedOut: "Para realizar un registro de salida",
  toContinueCreatingDiscount: "Para seguir creando este descuento crea primero una ubicación.",
  toContinueCreatingProducts: "Para seguir creando este producto, crea primero una ubicación.",
  toContinueCreatingStaff: "Para seguir creando este personal, crea primero una ubicación.",
  toContinueCreatingStocktake:
    "Para continuar creando este inventario, crea primero una ubicación.",
  toDeleteItem: "para eliminar este artículo.",
  today: "Hoy",
  together: "Juntos",
  toLabel: "Hasta",
  topCategoriesBySales: "Categorías principales por ventas",
  topLocations: "Puntos de venta principales",
  toppedUp: "Recargado",
  topProducts: "Productos principales",
  topSpendingGuests: "Huéspedes que más gastan",
  topupAndReturnCredits: "Créditos de recarga y devolución",
  topupCredits: "Créditos de recarga",
  topupCreditsRoleAppDesc: "Este rol no tiene acceso al sitio web.",
  topupCreditsRoleDashboardDesc: "Permite el acceso a la recarga de la aplicación.",
  topUpOutlet: "Punto de venta de recargas",
  total: "Total",
  totalAmount: "Importe total",
  totalBookings: "Total de reservas",
  totalCreditsKept: "Total de créditos retenidos (después de finalizar la compra)",
  totalCreditsReceived: "Total de créditos recibidos",
  totalFreeCreditsIssued: "Total de créditos gratuitos emitidos",
  totalFreeCreditsRemoved: "Total de créditos gratuitos eliminados",
  totalInStock: "Total en stock",
  totalPaid: "Total pagado",
  totalProductSales: "Total de productos vendidos",
  totalRefundedCredits: "Total de créditos reembolsados",
  totalRemoved: "Total eliminado",
  totalReturnCredits: "Total de créditos devueltos",
  totalReturnedCredits: "Total de créditos devueltos",
  totalSales: "Ventas totales",
  totalSpent: "Total gastado",
  totalSpentToDate: "Total gastado hasta la fecha",
  totalStocksPerLocation: "Total de existencias por ubicación",
  totalTagsUsed: "Total de etiquetas emitidas",
  totalTax: "Total de impuestos",
  totalTopUps: "Total de recargas",
  totalTopupCredits: "Total de créditos de recarga",
  totalTransactions: "Total de transacciones",
  totalUnspentCredits: "Total de créditos no gastados",
  totalUnspentCreditsDesc:
    "Suma de todos los créditos no gastados de los huespedes que están vinculados a su {0} y están programados para salir entre las fechas de su filtro anterior.",
  totalUse: "Uso total",
  totalVisits: "Total de visitas {0}",
  totals: "Totales",
  trackAndManage: "Controla y gestiona los recuentos manuales de inventario.",
  trackEveryGuestCheckedIn:
    "Haz un seguimiento de cada huésped registrado en tu espacio y obtén acceso a sus productos y ubicaciones favoritos",
  trackWhichItemsLow:
    "Haz un seguimiento de los artículos bajos en existencias y que necesitan reponerse",
  trackedInventory: "Seguimiento de inventario",
  transaction: "Transacción",
  transactionID: "ID de transacción",
  transactionId: "ID de transacción",
  transactionInfoPage: "Página de información de la transacción",
  transactionsNotSynchronizingToMews: "¿Las transacciones no se sincronizan con MEWS?",
  transactionStatus: "Estado de la transacción",
  transactionType: "Tipo de transacción",
  transactions: "Transacciones",
  transactionsFailedToProcess: "Las transacciones no se han podido procesar.",
  transactionsPage: "Página de transacciones",
  transfer: "Transferir",
  transferQuantityCannotExceedOriginal: "La cantidad a transferir no puede ser mayor que la cantidad original",
  transferSupplyItems: "Transferir artículos de suministros",
  transferSupplyItemsSuccessfully: "Transferir artículos de suministros con éxito",
  transferSupplyItemsTxtConfirm:
    "¿Está seguro de que desea transferir artículos de suministros de {0} a {1}",
  transferTo: "Transferir a",
  try: "Intento:",
  tuesday: "Martes",
  turnOffPos: "¿Desactivar la venta de {0} {1}?",
  turnOnPos: "¿Activar la venta de {0} {1}?",
  txnId: "Txn Id: #",
  type: "Escribe",
  typeAQuestion: "Escribe una pregunta",
  typeAReason: "Escribe un motivo...",
  typeAnOption: "Escribe una opción",
  typeDisconnect: "Escribe DISCONNECT en mayúsculas para confirmar",
  typeHere: "Escribe aquí...",
  typeToSearch: "Escribe para buscar un artículo",
  typeToSetAccountCode: "Escribe para establecer/seleccionar un código de cuenta.",
  unableToDelete: "No se puede borrar",
  unableToLoadTheMap: "No se pudo cargar el mapa. Verifique su conexión a internet e inténtelo de nuevo.",
  unableToValidateTheFile: "No se pudo validar el archivo.",
  unbaleToUploadMoreThanMb: "No se puede cargar imágenes con más de 1mb.",
  unban: "Desbloquear",
  unbanTag: "Desbloquear la etiqueta",
  unbanningWillMakeTagAccessible: "El desbloqueo hará que esta etiqueta sea accesible en tu local.",
  uncategorized: "Sin categoría",
  undefinedError: "Error no definido",
  undefinedErrorPlsTryAgain: "Error no definido. Actualice la página e inténtelo de nuevo.",
  undo: "DESHACER",
  unitSold: "Unidad vendida",
  unitsSold: "Unidades vendidas",
  unknown: "Desconocido",
  unspentCredit: "Crédito no gastado",
  updatedFrom: "Actualizado desde",
  transferFrom: "Transferido desde",
  updatedOn: "actualizado el {0}",
  uploadPhoto: "Subir foto",
  uponRegistration:
    "en el momento del registro o con cualquier personal/quiosco de recarga dentro del espacio.",
  usage: "Uso",
  usageDatePeriod: "Uso de fechas",
  useVenueAppAndLogin:
    "Utiliza la app del espacio y accede con tu etiqueta NFC activada o con tu nombre de usuario o contraseña actual.",
  used: "Usado",
  usesLastIssuedTo: "Usados, emitidos por última vez a",
  validUntilWithColonSymbol: "Válido hasta;",
  value: "Valor",
  valueBetween: "El valor debe estar entre",
  valueCanStillChangeTooltip: "Este valor aún puede cambiar si los huéspedes siguen gastando créditos en su establecimiento.",
  valueRedeemed: "Valor canjeado",
  values: "valores",
  variant: "Variante",
  variantAlreadyExist: "La variante ya existe",
  variantIsCurrentlyBeingUsed:
    "Esta variante está siendo usada en el siguiente producto en este momento",
  variants: "Variantes",
  vatReg: "Reg. de IVA",
  venueCurrency: "Moneda del espacio",
  venueDashboard: "Panel de control del espacio",
  venueDetails: "Detalles del espacio",
  venueInformation: "Información Venue",
  venueLocation: "Ubicación del espacio",
  venueName: "Nombre del espacio",
  venueNameAlreadyExist: "El nombre del espacio ya existe, por favor elige otro nombre",
  venueSettings: "Configuración del espacio",
  veryHighDenominations: "Denominaciones mui altas",
  view: "Ver",
  viewAllTransactions: "Ver todas las transacciones",
  viewAndExportDiscountReport:
    "Ver y exportar la lista de descuentos y el importe total deducido por cada descuento",
  viewAndExportEachClosedRegister:
    "Ver y exportar cada informe de registro cerrado realizado por el personal",
  viewAndExportSalesReportByCategories: "Ver y exportar el informe de ventas por categorías",
  viewAndExportVoucherReport:
    "Ver y exportar todos los vales aplicados en productos canjeados y el importe total de venta al por menor y suministro canjeado por cada vale",
  viewBasicSummary: "Ver resumen básico",
  viewBillingStatement: "Ver extracto de facturación",
  viewBookingInfo:
    "Ver la información de reservas de diferentes plataformas como MEWS, SoCashless Ticketing, ¡y más!",
  viewCategoryDetails: "Ver detalles de categoría",
  viewDetails: "Ver detalles",
  viewDevice: "Ver dispositivo",
  viewDiscountDetails: "Ver detalles de descuentos",
  viewEveryTransactions:
    "Ver todas las transacciones realizadas en el espacio dentro de un periodo determinado de tiempo",
  viewFullDetails: "Ver detalles completos",
  viewIntegrations: "Ver integraciones",
  viewNOfNTransactions: "Ver {0} / {1} Transacciones",
  viewNTransactions: "Ver {0} Transacciones",
  viewPlansAndPricing: "Ver planes y precios",
  viewPreview: "Ver vista previa",
  viewTaxSettings: "Ver configuración de impuestos",
  viewTheSalesSummaryOfYourVenue:
    "Ver resumen de ventas del espacio y las principales ubicaciones, productos y más.",
  viewVoucherDetails: "Ver detalles de vale",
  void: "Anular",
  voidAuthorization: "Anular autorización",
  voidConfirmation: "¿Seguro que quieres anular {0}? Esta acción no puede deshacerse.",
  voidId: "¿Anular {0}?",
  paymentInfo: "Info de pago",
  includedServiceCharge: "Cargo por servicio incluido.",
  voidInfo: "Info de anulación",
  voidReason: "Razón de anulación",
  voids: "Anulaciones",
  voidStocktake: "Anular inventario",
  voided: "Anulado",
  voidedBy: "Anulado por",
  voidedItems: "Artículos anulados",
  voidedOn: "Anulado el",
  voidedValue: "Valor anulado",
  voucher: "Vale",
  voucherApplied: "Vale aplicado",
  voucherAvailable: "Este vale está disponible para ser emitido tu espacio.",
  voucherCreated: "{0} añadido.",
  voucherDeleted: "Vale {0} eliminado.",
  voucherMovementPage: "Página de movimiento de vales",
  voucherName: "Nombre del vale",
  voucherNameAlreadyExist: "Este nombre ya existe.",
  voucherNotApplied: "Vale no aplicado",
  voucherRedeemed: "Vale canjeado",
  voucherReport: "Informe de vales",
  voucherReports: "Informes de vales",
  voucherRetailValue: "Valor de venta de los vales",
  voucherSupplyValue: "Valor de los vales de suministro",
  voucherTransactions: "Transacciones de vale",
  voucherType: "Tipo de vale",
  voucherUpdated: "Vales actualizados",
  vouchers: "Vales",
  vouchersCreationLimitInfo:
    "Solo puedes crear un máximo de 8 vales por espacio. Puedes eliminar los vales caducados o inactivos para añadir más vales.",
  vouchersIssued: "Vales emitidos",
  vouchersListPage: "Página de lista de vales",
  vouchersMaximumNumberReached: "Número máximo de vales alcanzado.",
  vouchersRedeemed: "Vales canjeados",
  vouchersRemoved: "Vales eliminados",
  vouchersUsage: "Uso de vales",
  wait: "Esperar",
  waiters: "Meseros",
  warningMessage: "Mensaje de advertencia",
  watchTutorial: "Ver tutorial",
  weBuildCustomIntegrations: "Creamos integraciones personalizadas con sus sistemas existentes. Cuéntenos qué necesita.",
  weCouldNotFindAnyEmails: "No pudimos encontrar ningún correo electrónico",
  weCouldNotFindAnyGuestsWithThisCriteria:
    "No pudimos encontrar huéspedes con este criterio",
  wednesday: "Miércoles",
  week: "Semana",
  weHaveSentEmail: "Hemos enviado un correo electrónico",
  weHaveSentEmailTo: "Hemos enviado un correo electrónico a",
  weNeedAtLeastOneNumber: "Necesitamos al menos un número",
  weNeedYourDetailsToContinue: "Necesitamos tus datos para continuar",
  weRegretToInform: "Lamentamos informarte",
  weSuggestYouTo: "Te sugerimos",
  weWillSendYouAnEmail: "Te enviaremos un correo electrónico",
  weWillUpdateYouViaEmail: "Te actualizaremos por correo electrónico",
  weDidNotFoundReports: "No hemos encontrado ningún informe para tus filtros.",
  webhooks: "Webhooks",
  webhooksFor: "Webhooks para",
  webhooksInformation: "Información de webhooks",
  webhooksIntegration: "Integración de webhooks",
  weeksAfterCheckout: "semanas después de la salida",
  weightInGrams: "Peso en gramos",
  welcomeBack: "¡Hola de nuevo!",
  whatAreFreePostpaidCredits: "¿Qué son los Créditos Grats y los Créditos Postpago?",
  whenAnItemAlertLevel: "Cuando un artículo cae a su nivel de alerta.",
  whole: "Entero",
  welcome: "Bienvenido",
  welcomeTo: "Bienvenido a",
  whatIsStocktake: "¿Qué es el inventario físico?",
  whatsThis: "¿Qué es esto?",
  whenAnOrderIsPaid: "Cuando se paga un pedido",
  whenIGetANewBooking: "Cuando recibo una nueva reserva",
  whenIGetANewSale: "Cuando recibo una nueva venta",
  whenYouCreateABooking: "Cuando creas una reserva",
  whenYouHaveSettledATransaction: "Cuando hayas liquidado una transacción",
  whereDoYouWantToTakeAction: "¿Dónde quieres realizar la acción?",
  whereToFind: "Dónde encontrar",
  wholeProduct: "Producto completo",
  wholeProducts: "Productos completos",
  whoops: "Ups",
  whoopsSomethingWentWrong: "Ups, algo salió mal",
  withSufficientPermissions: "Con permisos suficientes",
  withThisPaymentMethod: "Con este método de pago",
  withThisPhone: "Con este teléfono",
  withPendingPayments: "Con pagos pendientes",
  withRemainingBalance: "Con saldo restante",
  workShift: "Turno de trabajo",
  wristbandKeeping: "Mantenimiento de la pulsera",
  wristbandTag: "Etiqueta de pulsera",
  wristbandTagKeeping: "Conservación de etiqueta de la pulsera",
  wristbandTagSettings: "Ajustes de etiqueta de la pulsera",
  writeADescription: "Escribe una descripción",
  writeADescriptionOptional: "Escribe una descripción (opcional)",
  writeAName: "Escribe un nombre",
  writeANameOptional: "Escribe un nombre (opcional)",
  writeAnEmail: "Escribe un correo electrónico",
  writeMessage: "Escribe un mensaje",
  xByHourOfDay: "{0} por hora del día",
  xConnectedFailed:
    "Parece que no podemos reconocer este token de acceso. Por favor, consulta las siguientes instrucciones para recuperar tu token de acceso.",
  xConnectedSuccessfully: "{0} Conectado con éxito",
  xIntegration: "Integración de {0}",
  xOverTime: "{0} en el tiempo",
  xY: "{0} {1}",
  year: "año",
  years: "años",
  yes: "Sí",
  yesContinue: "Sí, continuar",
  yesterday: "Ayer",
  youAreAboutToDelete: 'Estás a punto de eliminar el {0} "{1}". Esto no se puede deshacer.',
  youAreAboutToDeleteAQuestionThatIsLinked:
    "Estás a punto de eliminar una pregunta vinculada a un perfil de huésped. Esto no se puede deshacer.",
  youAreAboutToDeleteGuestProfile:
    "Estás a punto de eliminar este perfil de huésped. Esto no se puede deshacer.",
  youAreAboutToDeleteMultiple: "Estás a punto de eliminar el {0} {1}. Esto no se puede deshacer.",
  youAreAboutToDeletePaymentMethod: 'Estás a punto de eliminar el método de pago "{0}".',
  youAreAboutToDeleteQuestion:
    "Estás a punto de eliminar esta pregunta. Esto no se puede deshacer.",
  youAreAboutToDeleteStaffName:
    "Estás a punto de eliminar a {0} del personal. Este personal ya no tendrá acceso a {1}. Esta acción no se puede deshacer.",
  youAreAboutToDeleteStaffProfile:
    "Estás a punto de eliminar este perfil de personal. Esta acción no se puede deshacer.",
  youAreAboutToDeleteTax: 'Estás a punto de eliminar el impuesto "{0}".',
  youAreAboutToDisconnect:
    "Estás a punto de desconectar y eliminar permanentemente toda la información de esta app.",
  youAreAboutToRemoveFromMailingList:
    "Estás a punto de eliminar a {0} de esta lista de correo. Esta cuenta no podrá recibir alertas del nivel de existencias.",
  youAreAboutToRemoveMultipleProduct:
    "Estás a punto de eliminar {0} productos y sus variantes del inventario y de todas tus ubicaciones. Esto no se puede deshacer.",
  youAreAboutToRemoveProduct:
    "Estás a punto de eliminar este producto del inventario y de todas las ubicaciones. Esto no se puede deshacer.",
  youAreAboutToRemoveVariantProduct:
    "Estás a punto de eliminar este producto y sus {0} variantes del inventario y de todas las ubicaciones. Esto no se puede deshacer.",
  youAreAssigned: "Tienes asignados los siguientes roles:",
  youAreLoggedInAs: "Has iniciado la sesión como {0}",
  youCanChangeThisLater: "Puedes cambiarlo más tarde.",
  youCanFindMoreInformationAboutThisHere: "Puede encontrar más información sobre esto aquí.",
  youCanNowLogin: "Ya puedes iniciar sesión con tu e-mail y contraseña.",
  youDontHavePermission: "No tienes permiso para acceder a este enlace",
  youHaveUnsavedChanges: "Tienes cambios sin guardar en esta página.",
  youllFindYourBookingsHere: "Encontrarás tus reservas aquí.",
  yourCurrentAssignedRoles: "Tus roles asignados actualmente son",
  yourGeneralSettings: "Tus ajustes generales, como el nombre del espacio y la moneda.",
  yourMailingIsEmpty: "Tu lista de correo está vacía.",
  yourVenues: "Tus espacios",
  youveReachedTheEndOfTheList: "Has llegado al final de la lista.",
  zeroInventory: "Inventario cero",
  mapToSiigo: "Corresponde en Siigo",
  socashlessTax: "Impuesto en SoCashless",
  siigoDescSalesTax:
    "Vincular los impuestos en SoCashless a los impuestos correspondientes en Siigo. Si no selecciona un impuesto en Siigo, no se crearán las facturas que incluyan el impuesto.",
  salesTax: "Impuesto de ventas",
  paymentMethodInSiigo: "Forma de pago en Siigo",
  socashlessPaymentMethod: "SoCashless Forma de pago",
  siigoDescPaymentMethod:
    "Introduzca el nombre del producto o servicio al que se asociarán sus propinas. Este producto será creado (o actualizado, si ya existe) en Siigo y asociado con las propinas en el venue para propósitos de facturación.",
  siigoDescInventoryGroup:
    "En Siigo, un grupo de inventario se utiliza para organizar y categorizar productos similares. Si un producto en el venue no tiene asignado un grupo de inventario específico, se colocará automáticamente en el Grupo de Inventario por Defecto.",
  defaultInventoryGroup: "Grupo de inventario por defecto",
  productSettings: "Configuración del producto",
  siigoDescSeller: "Este vendedor será el vendedor para la factura creada en Siigo",
  seller: "Vendedor",
  siigoDescBill:
    "Es necesario que el tipo de descuento esté configurado como 'Porcentaje' y que esté activo en Siigo.",
  invoiceType: "Tipo de factura",
  syncFromSiigo: "Sincronizar desde Siigo",
  syncFromSiigoDesc:
    "Si añade o actualiza su información en Siigo (tipo de factura, vendedor, grupo de inventario, método de pago o impuestos), tendrá que sincronizarla de nuevo para que se corresponda con su equivalente en SoCashless.",
  pleaseFetchDataFromSiigoByClickingButtonBelow:
    "Por favor, obtenga los datos de Siigo haciendo clic en el botón de abajo",
  connectStatus: "Estado de conexión",
  siigoAccount: "Cuenta Siigo",
  youCanReviewQuestionInEachGuestProfile:
    "Puede revisar las preguntas en el perfil de cada huésped aquí",
  warningSiigoIntegrationDesc:
    "Para cumplir con la normativa de la DIAN, es obligatorio recopilar la siguiente información de los huéspedes: Nombre, Correo electrónico, Tipo de identificación e ID.",
  pleaseReadThisInstructionCarefully: "Lea atentamente estas instrucciones",
  warning: "Advertencia",
  siigoIntegrationDetail: "Detalle de la integración de Siigo",
  viewInfo: "Ver información",
  paymentTerms: "Condiciones de pago",
  totalItems: "Total artículos",
  unitPrice: "Precio Unitario",
  from: "De",
  invoiceDate: "Fecha de factura",
  invoiceNumber: "Número de factura",
  sendToDian: "Enviar a la DIAN",
  sendToSiigo: "Enviar a Siigo",
  cufe: "CUFE",
  siigoInvoiceNumber: "Número de factura Siigo:",
  viewInvoice: "Ver factura",
  siigoInvNo: "Número de factura Siigo",
  issueDate: "Fecha de emisión",
  resyncEInvoice: "Volver a sincronizar la factura electrónica",
  acceptedByDian: "Aceptado por la DIAN",
  dianError: "Error de la DIAN",
  invoicedInSiigo: "Facturado en Siigo",
  siigoError: "Error de Siigo",
  unbill: "No facturado",
  state: "Estado",
  searchEInvoicePlaceholder:
    "Buscar factura por número de factura Siigo, nombre del huésped o número CUFE",
  viewListInvoiceTitle:
    "Ver la lista de facturas de sus huéspedes con el registro de salida realizado",
  eInvoice: "Facturación electrónica",
  invoice: "Factura",
  siigoCardDesc:
    "Siigo es un avanzado software de contabilidad en línea con herramientas de facturación conformes con la DIAN, esencial para optimizar la eficiencia e impulsar el crecimiento empresarial.",
  connect: "Conectar",
  areYouSureSentToDian:
    "¿Está seguro de que desea enviar esta factura a la DIAN? Por favor, compruebe el destinatario antes de continuar.",
  connectedSuccessfully: "Conectado Correctamente",
  selectInvoiceType: "Seleccione el Tipo de Factura",
  selectSeller: "Seleccione el Vendedor",
  selectInventoryGroup: "Seleccione el Grupo de Inventario",
  chooseAPaymentMethod: "Seleccione el Método de Pago",
  chooseASaleTax: "Seleccione el Impuesto de Venta",
  termsInAllowingAccess2:
    "Al hacer clic en 'Permitir Acceso', usted autorizas a {0} a utilizar, recibir y almacenar su información. Puede detenerlo en cualquier momento en la configuración de Integraciones de su cuenta SoCashless.",
  connectSiigoToYourSocashlessAccount: "Conecte {0} a su cuenta SoCashless.",
  totalDiscount: "Descuento total",
  taxPercentage: "% impuesto",
  accessControlSidebar: "Control de Acceso",
  feesAndSurcharges: "Cargos adicionales",
  reservations: "Reservas",
  frontOfHouse: "Front Office",
  home: "Inicio",
  dailyClose: "Cierre diario",
  stock: "Existencias",
  refunds: "Reembolsos",
  frontOffice: "Oficina de recepción",
  refundVoucher: "Vale de reembolso",
  topupVoucher: "Vale de recarga",
  adjustmentVoucher: "Vale de ajuste",
  tips: "Propinas",
  deviceSyncStatus: "Estado de sincronización de dispositivos",
  voucherIssue: "Emisión de vale",
  voucherRemove: "Eliminación de vale",
  resyncVoucher: "Resincronizar vale",
  customerName: "Nombre del cliente",
  inHouse: "En el establecimiento",
  exportGuestReport: "Exportar informe de huéspedes",
  searchStaffEmailOrTagID: "Buscar por correo o ID de etiqueta del personal",
  guestRefundReport: "Informe de reembolsos de huéspedes",
  guestRefundReportDesc: "Gestiona los datos de reembolso de huéspedes para eventos",
  accessControlReport: "Informe de control de acceso",
  tipReport: "Informe de propinas",
  freeCreditsReport: "Informe de créditos gratuitos",
  discountAmount: "Importe del descuento",
  refundClaimReport: "Informe de reclamaciones de reembolso",
  refundClaimReportDesc:
    "Gestiona los datos de reclamaciones de reembolso de huéspedes para eventos",
  device: "Dispositivo",
  notesAndGuideline: "Notas y directrices",
  appVersion: "Versión de la app",
  appDate: "Fecha de instalación / actualización de la app",
  totalCheckIn: "Total de registros de entrada",
  totalTopUp: "Total de recargas",
  transactionLastSynced: "Última sincronización de transacción",
  version: "Versión",
  manageOfPermissionToEnterSpecificAreas: "Gestiona los permisos de acceso a áreas específicas",
  addAndManageAdditionalCharge: "Añade y gestiona cargos adicionales para la venta en POS.",
  tip: "Propina",
  allowAndSetTip: "Permitir propina y establecer porcentajes",
  outlet: "Punto de venta",  accepted: "Aceptado",
  accessKey: "Clave de acceso",
  accessPoint: "Punto de acceso",
  accessPointCreateSuccess: "Punto de acceso creado exitosamente",
  accessPointExisted: "Este punto de acceso ya existía. Elige un nombre diferente",
  accessPointName: "Nombre del punto de acceso",
  accessURLOrQRCode: "Acceder a URL o código QR",
  activateOnOnlineMenu: "Activar en el menú en línea",
  activateOnPOS: "Activar en Punto de Venta (POS)",
  addAProduct: "Agregar un artículo",
  addASupplyItem: "Agregar un artículo en stock",
  addCharge: "Agregar cargo",
  addOptions: "Agregar opciones",
  addPaymentGateway: "Agregar Pasarela de Pago",
  addProductLimit: "Para agregar más artículos, intente eliminar algunos artículos para crear otros nuevos o pídale al propietario del lugar que aumente su límite de artículos.",
  addProductLimitOwner: "Para agregar más artículos, intente eliminar algunos artículos para crear otros nuevos o actualice su plan para aumentar su límite de artículos.",
  addStaffLimit: "Para agregar más personal, intente eliminar parte del personal o pídale al propietario del lugar que aumente su límite de personal.",
  addStaffLimitOwner: "Para agregar más personal, intente eliminar parte del personal o actualice su plan para aumentar su límite de personal.",
  advancedReporting: "Informes avanzados",
  allAccessPoints: "Todos los puntos de acceso",
  allowCustomTip: "Permitir a los invitados agregar propinas personalizadas",
  allowedAccessPoint: "Punto de acceso permitido",
  allowedGuestProfile: "Perfil de invitado permitido",
  allowGuestProfile: "Permitir perfil de invitado",
  allowInstallationFromUnknownSources: "Permitir la instalación desde fuentes desconocidas",
  allowInstallationFromUnknownSourcesDesc: "Es posible que deba habilitar esta configuración en la configuración de seguridad de su dispositivo para instalar aplicaciones fuera de la tienda de aplicaciones oficial. Los pasos exactos pueden variar según el sistema operativo de su dispositivo.",
  allResponse: "Todas las respuestas",
  allSources: "Todas las fuentes",
  allState: "Todo el estado",
  allTransactionTypes: "Todos los tipos de transacciones",
  allVenues: "Todos los lugares",
  andManyMore: "¡y muchos más!",
  appReinstall: "Reinstalación de la aplicación",
  areYouSureYouWantToDeleteCharge: "¿Está seguro de que desea eliminar el elemento de cargo {0}?",
  areYouSureYouWantToDeletePaymentGatewaySetting: "¿Está seguro de que desea eliminar “{0}”? Ya no estará disponible en su configuración de pago.",
  areYouSureYouWantToSetAsDefaultPaymentGatewaySetting: "¿Está seguro de que desea configurar “{0}” como pasarela de pago predeterminada?",
  askVenueOwnerToUpgradePlan: "Pídale al propietario del lugar que actualice su plan y comience a utilizar esta función.",
  askYourAdminToUpdateAccess: "Si necesitas acceso al panel, pide a tu administrador que actualice tus permisos de acceso.",
  atLeast1GuestProfile: "Se requiere al menos 1 perfil de invitado",
  automaticallyAddThisChargeToTheCart: "¿Agregar automáticamente este cargo al carrito?",
  automaticallyAddThisChargeToTheCartDesc: "Una vez que se agregue el primer artículo al carrito, este cargo se agregará automáticamente. El personal puede eliminar este cargo.",
  available: "Disponible",
  awaiting: "Esperando",
  balance: "Saldo",
  balanceMovementsDescription: "Vea de qué lugar dentro del grupo de lugares proviene el resto de los invitados",
  balanceMovementsIn: "Movimientos de equilibrio en",
  balanceMovementsInPage: "Movimientos de equilibrio en",
  balanceMovementsOut: "Movimientos de equilibrio hacia afuera",
  balanceMovementsOutPage: "Movimientos de equilibrio hacia afuera",
  bargainAllowed: "Negociación permitida",
  bargainRequiresApproval: "La negociación requiere aprobación",
  bargainRequiresApprovalOnThisProduct: "Requerir autorización del administrador al cambiar el precio de este artículo en POS",
  beforeUpdatingTheAppPleaseEnsureAllDataIsSyncedBy: "Antes de actualizar la aplicación, asegúrese de que todos los datos estén sincronizados mediante:",
  billedTo: "Facturado a",
  bookingAccomodation: "Reserva de alojamiento",
  bookingGuests: "Reserva de invitados",
  bookingPrice: "Precio de reserva",
  cacheCleared: "Caché borrado",
  cancelCloseShift: "Cancelar Cerrar turno",
  cardApprovalNumber: "Número de aprobación de tarjeta",
  cardNumber: "Número de tarjeta",
  cashlessTransactionsWithDoor: "¡Transacciones sin efectivo con activación de cerradura de puerta!",
  cashSales: "Ventas en efectivo",
  changelog: "Registro de cambios",
  changesSavedSuccessfully: "Los cambios se guardaron correctamente",
  chargeCalculation: "Cálculo de carga",
  chargeDeleted: "Cargo {0} Eliminado",
  chargeItem: "Artículo de carga",
  checkinAmount: "Importe del check-in",
  checkoutOurEbook: "¡Consulta también nuestro libro electrónico sobre cómo optimizar tu lugar!",
  chooseAInventoryGroup: "Elija un grupo de inventario",
  clickHere: "haga clic aquí",
  close: "Cerrar",
  closeShift: "Cerrar turno",
  closeShiftWarning: "Asegúrese de que todas las transacciones estén sincronizadas antes de forzar el cierre del turno y utilícelo solo si no puede cerrar el turno en la aplicación.",
  cloudbeds: "Nubes",
  codeMustBeUnique: "El código debe ser único.",
  comingSoon: "Muy pronto",
  companyRegistrationNo: "Número de registro de la empresa.",
  confirm: "Confirmar",
  confirmationPending: "Pendiente de confirmación",
  confirmImport: "Confirmar importación",
  confirmImportDesc: "¿Está seguro de que desea importar artículos en stock?",
  connectPurchasePlus: "Conecte Purchase Plus a su cuenta SoCashless.",
  copiedCUEFnumber: "Número CUEF copiado",
  copiedCUFEnumber: "Número CUFE copiado",
  copy: "Copiar",
  copyTheApkDownloadUrl: "Copie la URL de descarga de APK proporcionada anteriormente o escanee el código QR con una aplicación de escáner QR.",
  createAccessPoint: "Crear punto de acceso",
  createAccountCode: "Crear código de cuenta",
  createVenue: "Crear lugar",
  createVenuePage: "Crear página de lugar",
  credentialsAreInvalid: "Vaya, cierta información no es válida. Por favor ingresa los datos correctos y vuelve a intentarlo.",
  creditCard: "Tarjeta de crédito",
  creditDebit: "Crédito/Débito",
  creditDebitSales: "Ventas de crédito/débito",
  creditsKept: "Créditos retenidos",
  creditsKeptByGuests: "Créditos retenidos por los invitados",
  creditsReceived: "Créditos recibidos",
  creditsReceivedFromVenues: "Créditos recibidos de otros lugares",
  customLabel: "Etiqueta personalizada",
  customName: "Nombre personalizado",
  customNameIsAlreadyExisting: "El nombre personalizado ya existe.",
  daily: "A diario",
  dateAndTime: "Fecha y hora",
  dayEnd: "Fin del día",
  dayStart: "Inicio del día",
  daySummary: "Resumen del día",
  defaultMode: "Modo predeterminado",
  defaultModeSettingDesc: "De forma predeterminada, la aplicación móvil estará configurada en este modo:",
  defaultTableName: "Nombre de tabla predeterminado",
  deleteAccessPoint: "Eliminar punto de acceso",
  deleteAccessPointDesc: "¿Está seguro de que desea eliminar este punto de acceso?",
  deleteCharge: "Eliminar cargo",
  deleteChargeFailed: "No se puede eliminar el cargo. Vuelve a intentarlo más tarde.",
  deletedSuccessfully: "Eliminado con éxito",
  deletePaymentGateway: "Eliminar Pasarela de Pago",
  deleteStaffModalDesc: "Está a punto de eliminar personal(es). Este personal ya no tendrá acceso al Venue. Esta acción no se puede deshacer.",
  deleteStaffModalNote: "Nota: Se conservarán sus transacciones anteriores con este personal.",
  deleteStaffSuccessfully: "Eliminar personal con éxito",
  deviceLimitExceeded: "Está utilizando dispositivos {0} que exceden el límite de su plan de dispositivos {1}. Comuníquese con el propietario del lugar para actualizar su plan.",
  deviceLimitExceededManager: "Está utilizando dispositivos {0} que exceden el límite de su plan de dispositivos {1}. Actualice su plan.",
  deviceUid: "ID del dispositivo",
  directory: "Directorio",
  disabled: "Desactivado",
  disclaimer: "Descargo de responsabilidad",
  disclaimerDesc: "Tenga en cuenta que no se recomienda el uso de versiones anteriores de nuestra aplicación y puede provocar problemas de rendimiento o vulnerabilidades de seguridad. Para garantizar un rendimiento óptimo y el más alto nivel de seguridad, recomendamos encarecidamente actualizar a la última versión de nuestra aplicación lo antes posible.\nGracias por su comprensión y cooperación.",
  displayName: "Nombre del comerciante",
  downloadAndSync: "Descargue la aplicación SoCashlessVENUE y sincronice su primera transacción",
  downloadAPK: "Descargar APK",
  downloadTemplate: "Descargar plantilla",
  editAccessPoint: "Editar punto de acceso",
  editCharge: "Editar cargo",
  editDetails: "Editar detalles",
  editDevice: "Editar dispositivo",
  editPaymentGateway: "Editar pasarela de pago",
  editSFTPDetails: "Editar detalles de SFTP",
  eInvoiceSyncSuccessfully: "La factura electrónica se ha sincronizado correctamente",
  enableDifferentiateEntryExit: "Habilitar entrada/salida diferenciada",
  enableTip: "¿Habilitar sugerencia?",
  endedBy: "Terminado por",
  endOfDayCompleted: "Cierre diario completado",
  endOfDayFailed: "No se pudo completar el cierre diario",
  endOfDayReportsListPage: "Página de lista de informes de cierre diario",
  endOfDayRunning: "El cierre diario se está ejecutando. Actualice la página para actualizar el estado de Hora de finalización de EOD.",
  error: "Error",
  eventMode: "Modo de evento",
  externalPaymentStatus: "Estado de pago externo",
  externalPayment: "Pago externo",
  featureLocked: "Función bloqueada",
  female: "Femenino",
  fileImported: "Archivo importado",
  findSimilar: "Buscar similares",
  followTheOnScreenInstructionsToCompleteTheDownloadAndInstallation: "Siga las instrucciones en pantalla para completar la descarga e instalación.",
  forDevicesWithoutTheGooglePlayStore: "Para dispositivos sin Google Play Store:",
  freeCreditsKept: "Créditos gratuitos mantenidos",
  freeCreditsReceived: "Créditos gratuitos recibidos",
  future: "Futuro",
  generateAndDownload: "Generar y descargar",
  generateQRCode: "Generar código QR",
  generateQRDescription: "Genere e imprima códigos QR para que los clientes los escaneen y realicen pedidos desde el menú en línea de esta ubicación.",
  getSocashlessVENUEeBook: "Obtenga el libro electrónico SoCashlessVENUE",
  goToThe: "Ir al",
  goToTheSiigoApiKey: "pantalla desde su Panel de Siigo para encontrar su clave API.",
  goToVenueTabAndTapOnPushVenueData: "Vaya a la pestaña \"Lugar\" y toque Enviar datos del lugar",
  guestId: "ID de invitado",
  guestProfileAmountPlaceholder: "0.00",
  guidelineDownloadOrUpdateApp: "Guía sobre cómo descargar o actualizar la aplicación",
  here: "aquí",
  hideOnlineMenu: "Ocultar en el menú en línea",
  hostname: "Nombre de host",
  hourly: "Cada hora",
  idType: "Tipo de identificación",
  ifYouHaveAPreviousVersionOfApp: "Si tiene una versión anterior de la aplicación, elimínela antes de actualizarla.",
  ignore: "Ignorar",
  ignoreAllOpenShifts: "Ignorar todos los turnos abiertos",
  ignoreAllShifts: "Ignorar todos los turnos",
  ignoredShiftFromPrevious: "Cambio ignorado desde el EOD anterior",
  inputReason: "Motivo de entrada",
  installAPK: "Instalar APK",
  integration: "Integración",
  interval: "Intervalo",
  inventoryExisted: "El inventario existía",
  inventoryGroup: "Grupo de inventario",
  inviteResponse: "Invitar respuesta",
  inviteYourStaff: "Invita a tu personal",
  invoiced: "Facturado",
  invoices: "Facturas",
  isDefault: "Es predeterminado",
  isDefaultPaymentGateway: "Pasarela de pago predeterminada",
  itemBargain: "El precio de este artículo ha cambiado de {0} a {1}",
  itemImport: "Importación de artículos",
  learnHowToRenewSubscription: "Aprende cómo renovar tu suscripción",
  linkOutlet: "Ubicación del enlace",
  linkOutletHoverTooltip: "Enlace a ubicaciones MEWS",
  litePlanMaxProductReached: "Has alcanzado el número máximo de artículos {0} con tu plan {1}.",
  litePlanMaxStaffReached: "Has alcanzado el número máximo de {0} personal con tu plan {1}.",
  locateAPK: "Localizar APK",
  locateAPKDesc: "Abra el administrador de archivos de su dispositivo y busque el APK en la carpeta \"Descargas\".",
  locationQRCode: "Código QR de ubicación (uno para toda la ubicación)",
  male: "Masculino",
  mainGuestTag: "Principal",
  manageTipDesc: "Habilite la propina y establezca el porcentaje de propina que le gustaría mostrar en el POS",
  manageVenues: "Administrar lugares",
  manuallyDownloadUpdateSocashlessApp: "Descargue/actualice manualmente la aplicación SoCashless desde Google Play Store:",
  maxProductReached: "Artículo máximo alcanzado",
  maxStaffReached: "Personal máximo alcanzado",
  menuEngineering: "Menú Ingeniería",
  merchantId: "Identificación del comerciante",
  merchantSecret: "Clave secreta",
  merchantUrl: "URL del comerciante",
  mews: "CABALLERIZA",
  mewsAccounting: "MEWS_Contabilidad",
  mewsAccounting1: "Contabilidad MEWS",
  mewsBookings: "MEWS_Reservas",
  mewsBookings1: "MEWS Reservas",
  mewsSystems: "Sistemas MEWS",
  mewsTaxCode: "¿El código fiscal es de MEWS?",
  mewsTaxCodeEditNote: "Nota: Cuando se sincronizan las transacciones, los artículos vinculados a este impuesto tendrán el monto del IVA en MEWS.",
  missingTransactionsDetected: "Transacciones faltantes detectadas",
  mode: "Modo",
  monthly: "Mensual",
  multiProperty: "Propiedad múltiple",
  na: "N / A",
  newSku: "Nuevo SKU",
  nfcStatus: "Estado NFC",
  nfcTags: "Etiquetas NFC",
  night: "noche",
  noAvailableAccessPoint: "No hay punto de acceso disponible",
  noDashboardAccess: "Actualmente no tienes acceso al panel.",
  noDataAvailable: "No hay datos disponibles",
  none: "Ninguno",
  noOfCheckedIn: "{0} registrado",
  noOfCheckedOut: "{0} retirado",
  noRecords: "Sin registros.",
  noSearchFound: "No se encontró ninguna búsqueda",
  noShow: "No presentarse",
  noteUpdateLastVersion: "Nota: Esta \"ventana emergente\" seguirá apareciendo hasta que todos sus dispositivos activos se actualicen a la última versión. Verifique la versión de la aplicación de sus dispositivos,",
  nowToDo: "ahora para hacer",
  oldGuestId: "ID de invitado antiguo",
  onboardingDescription: "Configure su lugar con estos sencillos pasos para comenzar.",
  onboardingDescriptionCompleted: "¡Impresionante! ¡Ya puedes empezar a vender en tus dispositivos POS SoCashlessVENUE! ¡Solicite sus etiquetas NFC ahora para realizar transacciones sin efectivo con activación de cerradura de puerta! ¡Consulta también nuestro libro electrónico sobre cómo optimizar tu lugar!",
  onboardingTitle: "¡Bienvenido! Comience a configurar su lugar.",
  onboardingTitleCompleted: "¡Tu lugar está listo para funcionar!",
  onceYoureOnTheAppsPage: "Una vez que estés en la página de la aplicación:",
  onceYoureOnTheAppsPageDesc: "Haga clic en el botón “Instalar”/“Actualizar”\n(Para actualizar la aplicación, Google Play Store buscará automáticamente actualizaciones y le pedirá que las actualice si es necesario).",
  onlineMenuOnly: "Menú en línea únicamente",
  onlyDateRangesLessThanOneYear: "Sólo se aceptan rangos de fechas inferiores a un año.",
  opened: "Abierto",
  orderQuantityRequired: "Se requiere la cantidad del pedido",
  orderYour: "Ordena tu",
  pasteUrlInDeviceBrowserAndDownload: "Pegue la URL en el navegador de su dispositivo y descargue el APK o siga el enlace del código QR para descargar el APK.",
  paymentGatewayDeleted: "Pasarela de pago \"{0}\" eliminada.",
  paymentGatewayName: "Nombre de la pasarela de pago",
  paymentGatewayUpdated: "Pasarela de pago \"{0}\" actualizada.",
  payments: "Pagos",
  paymentsListSettings: "Configuración de la lista de pasarelas de pago",
  paymentsSettings: "Configuración de pago",
  phoneNo: "Número de contacto.",
  pleaseContactOwnerToReactiveVenue: "Comuníquese con el propietario del lugar para renovar la suscripción y reactivar este lugar.",
  pleaseContactSupportRenewSubscription: "Comuníquese con el soporte para renovar su suscripción y reactivar su lugar.",
  pleaseCopyUrl: "Copie la siguiente URL y péguela en su navegador o escanee el código QR:",
  pleaseCopyUrlApk: "Si su dispositivo no tiene Google Play Store, descargue la aplicación desde la URL a continuación o escanee el código QR con el dispositivo:",
  pleaseCreateAccounts: "Cree códigos de cuenta desde su plataforma de contabilidad integrada.",
  pleaseEmailUs: "Envíenos un correo electrónico a {0} {1}",
  pleaseEnterYourSFTP: "Ingrese los detalles y las credenciales de su servidor SFTP.",
  pleaseMakeSureToSyncAllDataBeforeDeleteApp: "Asegúrese de sincronizar todos los datos antes de eliminar la aplicación.",
  pleaseRenewSubscription: "Renueva tu suscripción para reactivar tu lugar.",
  pleaseUpgradeToUseLockedFeature: "Actualice su plan para utilizar esta función bloqueada.",
  posAndOnlineMenu: "TPV + Menú Online",
  socashlessPay: "SoCashlessPAY",
  preloadedCredit: "Crédito precargado",
  prepareImport: "Preparando la importación",
  productCodeInSiigo: "Código de artículo en Siigo",
  productForTips: "Artículo para propinas",
  purchasePlus: "CompraPlus",
  purchaseplus: "Compra Plus",
  qrCodeForOnlineMenu: "Código QR para Menú Online",
  quarter: "Cuarto",
  quarterly: "Trimestral",
  referenceNo: "Árbitro. No.",
  registeredBusinessTaxNumber: "Número de impuesto comercial registrado",
  registeredOfficialBusinessName: "Nombre comercial registrado/oficial",
  regulateEntryExit: "Regular la entrada/salida",
  regulateEntryExitDesc: "La activación de esta función permite una regulación precisa de la entrada y salida en el punto de acceso.\nCuando se desactiva, el control de acceso sigue siendo funcional, pero no diferenciará entre entradas y salidas.",
  removeSku: "SKU eliminado",
  removeStaff: "¿Quitar personal?",
  renewSubscription: "Renovar suscripción",
  reportingDay: "Día del informe",
  resync: "Volver a sincronizar",
  resyncSuccessfully: "Volver a sincronizar correctamente",
  returnCreditsRoleDashboardDesc: "Permite el acceso a los créditos de devolución de la aplicación Venue",
  revenueAccountMessage: "La cuenta predeterminada para todos los ingresos por ventas.",
  running: "Correr",
  runningTheEodWithUnsynced: "Ejecutar el EOD con transacciones no sincronizadas generará un informe incompleto.",
  salesSummary: "Resumen de ventas",
  scanningTheQRcode: "Escaneando el código QR",
  scanningTheQRcodeDesc: "Abra la aplicación de la cámara de su dispositivo y apunte su cámara al código QR proporcionado. Esto abrirá automáticamente un enlace a la página de la aplicación en Google Play Store.",
  scanningTheQRcodeOrUsingUrl: "Escanear el código QR o usar la URL",
  scanQRcode: "Escanear código QR",
  searchCategories: "Busque y seleccione categorías para este bono",
  searchGuestsBalanceMovements: "Buscar invitados por nombre o ID de etiqueta",
  searchPaymentGateway: "Buscar por nombre de pasarela de pago",
  seeError: "Ver error",
  selectAccessPoints: "Seleccionar puntos de acceso",
  selectCharge: "Seleccionar cargo",
  selectInventoryGroupFormSiigoToAssign: "Seleccione un grupo de inventario de Siigo para asignarlo a este artículo",
  selectNumberOfTables: "Seleccione el número de mesas",
  selectOutlet: "Seleccionar Ubicación",
  selectProductForTips: "Seleccione un artículo para recibir propinas",
  selectRedeemableProducts: "Seleccionar artículos canjeables",
  selectSource: "Seleccionar fuente",
  sellingQtyMustBeGreaterThanZero: "La cantidad de venta debe ser mayor que cero.",
  sendTo: "Enviar a",
  sendToDianSuccessfully: "Enviado a la DIAN exitosamente",
  sendToSiigoSuccessfully: "Enviar a Siigo con éxito",
  setDefaultPaymentGateway: "Establecer pasarela de pago predeterminada",
  setupYourPaymentGateways: "Configure sus pasarelas de pago",
  shiftAlreadyClosed: "Este turno ya está cerrado.",
  shiftClosed: "Turno cerrado",
  shiftsAndTransactions: "Turnos y Transacciones",
  showErrorInvoiceOnly: "Mostrar solo factura con error",
  showNumOutDateDevices: "Nuestro sistema muestra que solo los dispositivos {0} se han actualizado a la última versión. Actualice los dispositivos restantes a la última versión.",
  showOnlineMenu: "Mostrar en el menú en línea",
  siigo: "Siigo",
  siigoAccountConnectedToDian: "Cuenta de Siigo conectada a la DIAN",
  siigoDescProductForTips: "El artículo que se utilizará para facturar las propinas que recibas.",
  someShiftsHaveUnsynced: "Algunos turnos tienen transacciones no sincronizadas. Por favor verifique los dispositivos de los turnos para enviar los datos del lugar.",
  sorryVenueSuspended: "Lo sentimos, este lugar ha sido suspendido.",
  source: "Fuente",
  specificCategories: "Categorías específicas",
  specificProducts: "Artículos específicos",
  step: "Paso",
  stockLevel: "Nivel de existencias",
  subscription_only_owner_access: "Solo el propietario del lugar que se suscribió a este plan puede acceder a esta suscripción",
  subscriptionCanceledReason: "Has cancelado tu suscripción.",
  subscriptionExpiredReason: "Has cancelado tu suscripción.",
  subscriptionSuspended: "La suscripción ha finalizado. Comuníquese con el propietario del lugar para renovar la suscripción antes de {1} para conservar el acceso a {2}.",
  subscriptionSuspendedIn5: "Este lugar está a punto de ser suspendido en 5 días. Comuníquese con el propietario del lugar para renovar la suscripción antes de {0} para conservar el acceso a {1}.",
  subscriptionSuspendedIn5Manager: "Tu local va a ser suspendido en menos de 5 días. Renueve su suscripción antes de {0} para conservar el acceso a {1}.",
  subscriptionSuspendedManager: "{0} Renueve su suscripción antes de {1} para conservar el acceso a {2}.",
  subscriptionSuspendedToday: "Su lugar será suspendido hoy. Comuníquese con el propietario del lugar para renovar la suscripción y conservar el acceso a {0}.",
  subscriptionSuspendedTodayManager: "Su lugar será suspendido hoy. Renueve su suscripción hoy para conservar el acceso a {0}.",
  subscriptionUnpaidReason: "Parece que hay un problema con tus datos de pago.",
  supportSocashless: "soporte@socashless.com",
  suspended: "Suspendido",
  syncFromSiigoSuccessfully: "Sincronización desde Siigo realizada correctamente",
  syncToDian: "Sincronizar con la DIAN",
  tableQRCode: "Códigos QR de mesa (por mesa)",
  tapOnTheAPKFileToStartTheInstallationProcess: "Toque el archivo APK para iniciar el proceso de instalación. Siga las instrucciones que aparecen en pantalla para completar la instalación. Una vez instalada, abra la aplicación desde el cajón de aplicaciones o la pantalla de inicio.",
  taxCode: "Código fiscal",
  taxInvoiceNo: "Número de factura de impuestos:",
  termsInAllowingAccess3: "Al hacer clic en Permitir acceso, autoriza a {0} a almacenar su información {1}. Revise nuestros {2} y {3}.",
  theActualNumberOfGuests: "El número real de huéspedes que realizan el check-in/out",
  theBookingStatus: "El estado de la reserva desde la fuente.",
  theGuestHasNoAssignedRoom: "¡El huésped no tiene habitación asignada!",
  theLastVersion: "Última versión de la aplicación:",
  theLastVersionOfAppAvailable: "La última versión de la aplicación {0} ya está disponible en Google Play Store.",
  theseNthOtherProducts: "{0} {1} otros artículos con esta ubicación y otras ubicaciones permanecerán en su inventario.",
  theUpdateShouldBeAppliedAutomatically: "La actualización debería aplicarse automáticamente, pero también puede abrir el enlace a continuación o escanear el código QR para descargar la última versión de la aplicación.",
  thisGuestHasNotCheckedOutYet: "Este huésped aún no ha realizado el check-out",
  thisIsForDirectIntegrationWithPaymentTerminalPartner: "Esto es para integración directa con Payment Terminal Partner",
  thisShiftHasUnsyncedTransactions: "Este turno tiene transacciones no sincronizadas.",
  thisUrlIsInvalid: "Esta URL no es válida.",
  ticketing: "Venta de entradas",
  ticketNo: "Número de billete",
  timeout: "Se acabó el tiempo",
  tipOptions: "Opciones de propina",
  tipsAndCharges: "Propinas y cargos",
  toScheduleACall: "Para programar una llamada con nuestro servicio de atención al cliente.",
  totalCreditsKeptByGuests: "Créditos totales retenidos por los invitados",
  totalCreditsKeptTooltip: "Cantidad total de créditos que los huéspedes conservaron después del check out",
  totalCreditsReceivedFromVenues: "Créditos totales recibidos de otros lugares",
  totalCreditsReceivedTooltip: "Cantidad total de créditos recibidos de huéspedes registrados con créditos retenidos de otros lugares",
  totalExpectedEndingBalance: "Saldo final total esperado",
  totalOpeningBalance: "Saldo total de apertura",
  totalRefunded: "Total reembolsado",
  toViewDetailedInstructions: "Para ver instrucciones detalladas",
  tradeTypeTransactionNumber: "{0} Trans No",
  unignore: "Dejar de ignorar",
  unignoreAllOpenShifts: "Dejar de ignorar todos los turnos abiertos",
  unignoreAllShifts: "Dejar de ignorar todos los turnos",
  updatedVersionOfTheAppIsNowAvailable: "¡La versión actualizada de la aplicación ya está disponible!",
  upgradeNow: "Actualiza ahora",
  upgradePlanHeader: "¡Mejore su lugar y acceda a más funciones premium cuando actualice su plan ahora!",
  upgradeYourPlan: "¡Actualiza tu plan! ✨",
  upload: "Subir",
  uploadExcelFileToImport: "Subir archivo excel para importar",
  upToDate: "Al día",
  user: "Usuario",
  username: "Nombre de usuario",
  useThisVenueDetails: "Utilice los detalles de este lugar",
  usingTheURL: "Usando la URL",
  usingTheURLdesc: "Abra su navegador web y pegue la URL proporcionada en la barra de direcciones y presione Entrar y esto lo llevará a la página de la aplicación en Google Play Store.",
  venue: "Espacio",
  venueInLitePlan: "Este lugar se encuentra actualmente en el Plan Lite.",
  venueLogo: "Logotipo del espacio",
  venueMode: "Modo espacio",
  venueSuspended: "Lugar suspendido",
  viewAccountOnSiigo: "Ver cuenta en Siigo",
  viewAndExportFreeCreditsReport: "Ver y exportar créditos gratuitos emitidos y eliminados.",
  viewBy: "Ver por",
  viewPaymentGateway: "Ver Pasarela de Pago",
  viewPrinter: "Ver impresora",
  voucherReachedIssuanceLimit: "Este bono ha alcanzado su límite máximo de emisión de {0}.",
  warningResyncDesc: "Todavía faltan transacciones en el sistema de factura electrónica debido a dispositivos fuera de línea.\nAsegúrese de que todos los dispositivos del lugar estén conectados a Internet y que sus datos se envíen al sistema para completar la sincronización, luego haga clic en el botón “Volver a sincronizar la factura electrónica” para actualizar la factura.",
  weekMon2Sun: "Semanal (de lunes a domingo)",
  weekSun2Sat: "Semanal (domingo a sábado)",
  wouldReadOrWrite: "{0} leería y/o escribiría la siguiente información:",
  yourSubscriptionCanceled: "Tu suscripción al plan {0} para tu lugar, {1, fue cancelada.",
  yourSubscriptionEnded: "Tu suscripción al plan {0} para tu lugar, {1, ha finalizado.",
  youAreCurrentlyInSiigoEnv: "Estás habilitando el entorno Siggo para este lugar. Tenga en cuenta que esta configuración no admite la función \"Cargos adicionales\".",
  youAreEnablingSiigo: "Estás habilitando el entorno Siggo para este lugar. Tenga en cuenta que la función \"Cargos adicionales\" no es compatible con esta configuración.",
  setToDefault: "Establecer como predeterminado",
  registerForRefund: "Regístrese para recibir reembolso",
  refund: "Reembolso",
  onGroundReport: "Resumen de registro y acceso a la reserva",
  multipleInReport: "Acceso múltiple en",
  guestProfileId: "ID del perfil del invitado",
  totalSold: "Total vendido",
  totalActivated: "Total activado",
  activePercentage: "Activo %",
  totalAccessIn: "Acceso TotalEn",
  accessedPercentage: "% accedido",
  notActivated: "No activado",
  notActivatedPercentage: "% no activado",
  notAccessed: "No accedido",
  notAccessedPercentage: "% no accedido",
  onGround: "Informe en tierra",
  inactiveBookingReport: "Resumen de reserva inactiva",
  transactionRefundReport: "Reembolsos totales",
  topupAndSaleSummaryReport: "Resumen de recarga y venta",
  remainingBalanceReport: "Saldo restante de la billetera",
  duplicateTicketsReport: "Informe de entradas duplicadas",
  enableKiosk: "Habilitar quiosco",
  totalDistinctWalletsUsedForTransactions: "Total de billeteras distintas utilizadas para transacciones",
  countOfWalletWithCashRemaining: "Recuento de billetera con efectivo restante",
  ticketType: "Tipo de billete",
  topUpAndSalesSummaryReport: "Recarga y resumen de ventas",
  totalRefundReport: "Reembolso total",
  yourMightGetNegative: "El informe solicitado está destinado al modo Eventos mientras usted está en el modo Sedes.",
  maximumTopUp: "Recarga Máxima",
  mdr: "MDR",
  tagUid: "ID de etiqueta",
  tagBalance: "Saldo de la etiqueta",
  eventStartDateTime: "Fecha de inicio y finalización del evento",
  event: "Evento",
  transactionStartDateTime: "Fecha de inicio y finalización de la transacción",
  refundStartDateTime: "Fecha de inicio y finalización del reembolso",
  mdrCharges: "Cargos MDR",
  amountClaimed: "Monto reclamado",
  claimDate: "Fecha de reclamación",
  claimStatus: "Estado del reclamo",
  refunded: "Reintegrado",
  registered: "REGISTRADO",
  exported: "Exportado",
  kiosk: "Quiosco",
  minimumTopUp: "Recarga mínima",
  deviceLocation: "Ubicación del dispositivo",
  connectToSiigo: "Conéctate a Siigo",
  connectToSiigoDesc: "Para utilizar la implementación de Siggo, comuníquese con nuestro equipo de administración para obtener acceso.",
  eventTimeZone: "Zona horaria del evento",
  searchByGuestNameEmailTagUid: "Buscar por nombre del huésped, correo electrónico/teléfono, etiqueta UID",
  amountRecieved: "Cantidad recibida",
  gHL: "GHL",
  pendingUnbill: "Sincronización de transacciones no facturadas pendiente",
  cancelationReport: "Informe de cancelación",
  cancelationReportDesc: "Ver la lista de boletos cancelados.",
  cancelTicket: "Cancelar billete",
  ticketDetails: "Detalles del boleto",
  ticketCancelled: "Boleto cancelado",
  timeZone: "Huso horario",
  isAppliedForStaff: "Solicitado para personal",
  voucherId: "ID de cupón",
  voucherTransaction: "Transacción de vale",
  voucherDate: "Fecha del bono",
  guestTagUid: "UID de etiqueta de invitado",
  tagUseCount: "Recuento de uso de etiquetas",
  model: "Modelo",
  osVersion: "Versión del sistema operativo",
  firmwareVersion: "Versión de firmware",
  softwareVersion: "Versión de software",
  ghlVersion: "Versión de la aplicación GHL",
  ttbVersion: "Versión de la aplicación TTB",
  userDetails: "Detalles del usuario registrado",
  deviceRegisterDateTime: "Registro del dispositivo Fecha Hora",
  deviceLastLocationDateTime: "Última actualización de ubicación Fecha Hora",
  mdmDeviceList: "Lista de dispositivos MDM",
  mdmDeviceListDescription: "Ver y administrar información del dispositivo MDM",
  mdm: "DM",
  deviceGeoLocation: "Ubicación geográfica del dispositivo",
  deviceGeoLocationDescription: "Ver ubicaciones de dispositivos en un mapa interactivo",
  deviceLocationMap: "Mapa de ubicación del dispositivo",
  selectDeviceLocation: "Seleccione la ubicación del dispositivo",
  showingDevicesOnMap: "Mostrando dispositivos en el mapa",
  searchMdmDevices: "Buscar dispositivos MDM...",
  topup: "Recarga",
  unsyncTransactionReports: "Informe de salud del síndrome premenstrual",
  count: "Contar",
  monthlySaleReport: "Informe de venta mensual",
  subscriptionPlanName: "Plan de suscripción",
  subscriptionCustomerId: "ID de cliente",
  allowNonNfcActivationProfile: "Permitir activación sin NFC para este perfil de invitado",
  nonNfcActivation: "Activación sin NFC",
  adjustment: "Ajuste",
  importFile: "Importar archivo (.xlsx)",
  importFail: "¡Error de importación!",
  fileSizeExceeded: "El tamaño del archivo excede el límite permitido de {0}. Divida los datos en dos archivos y utilice la función de carga incremental para continuar.",
  invalidBookingFileType: "Formato de archivo no válido. Solo se admiten archivos {0} para la importación. Cargue un archivo {1} válido e inténtelo de nuevo.",
  selectImportType: "Seleccione el tipo de importación",
  selectImportTypeDesc: "¿Está realizando una importación incremental o nueva?",
  incremental: "Incremental",
  newBookingDataImport: "{0} se eliminará el registro de datos existente y {1} se cargarán nuevos registros de datos. ¿Aún quieres continuar?",
  topUpType: "Recarga",
  refundType: "Reembolso",
  documentType: "Tipo de documento",
  selectTopupType: "Seleccione el tipo de recarga",
  selectRefundType: "Seleccione el tipo de reembolso",
  outletName: "Nombre de la ubicación",
  createOutlet: "Crear ubicación",
  editOutlet: "Editar ubicación",
  deleteOutlet: "Eliminar ubicación",
  topupAccount: "Recarga",
  refundAccount: "Reembolso",
  invoiceAccount: "Factura",
  you: "Tú",
  youAreAuthorizedToAccess: "Tienes autorización para acceder",
  youAreNotAuthorized: "No tienes autorización",
  youCanAlso: "También puedes",
  youCanStillAccess: "Aún puedes acceder",
  youCannotAddPastTime: "No puedes agregar una hora pasada",
  youCannotRemovePastTime: "No puedes eliminar una hora pasada",
  youDontHaveSufficientPermissions: "No tienes permisos suficientes",
  youHaveAMessage: "Tienes un mensaje",
  youHaveNoBooking: "No tienes reservas",
  youHaveNoClosedRegisters: "No tienes cajas cerradas",
  youHaveNoData: "No tienes datos",
  youHaveNoOpenShifts: "No tienes turnos abiertos",
  youHaveNoTransactions: "No tienes transacciones",
  youHaveNoVoucher: "No tienes vales",
  youHaveNoVoucherCredits: "No tienes créditos de vale",
  youHaveNotAddedAnyCategory: "No has agregado ninguna categoría",
  youHaveNotSelectedAnyProducts: "No has seleccionado ningún producto",
  youHaveNotYetCreatedAnyVoucher: "Aún no has creado ningún vale",
  youHaveSelected: "Has seleccionado",
  youMustAddAtLeastOneTag: "Debes agregar al menos una etiqueta",
  youMustAddAtLeastOneTicketType: "Debes agregar al menos un tipo de ticket",
  youMustAssignUser: "Debes asignar un usuario",
  youMustFillInAllFields: "Debes completar todos los campos",
  youMustSetAtLeastOneAccessRule: "Debes configurar al menos una regla de acceso",
  youMustSpecifyAValue: "Debes especificar un valor",
  youSure: "¿Estás seguro?",
  yourBookingWasSuccessfullyCanceled: "Tu reserva se canceló correctamente",
  yourBookingWasSuccessfullyCreated: "Tu reserva se creó correctamente",
  yourBookingWasSuccessfullyUpdated: "Tu reserva se actualizó correctamente",
  yourBookings: "Tus reservas",
  yourPasswordHasBeenReset: "Tu contraseña ha sido restablecida",
  yourPasswordHasBeenSuccessfullyChanged: "Tu contraseña se cambió correctamente",
  yourQuestion: "Tu pregunta",
  yourSessionIsInvalid: "Tu sesión no es válida",
  yourTagIsNotAllowed: "Tu etiqueta no está permitida",
  yourVoucherHasExpired: "Tu vale ha expirado",
  zeroQuantity: "Cantidad cero",
  zeusDescription: "Gestión hotelera creada para alojamientos sociales de alto volumen.",
  zipCode: "Código postal",
  arrivalTime: "Hora de llegada",
  arrivalTimeReport: "Informe de horas de llegada",
  arrivalTimeStatisticView: "Vista estadística de horas de llegada",
  arrivalTimeStatisticViewDesc: "Consulta las llegadas previstas de huéspedes y el registro de formularios por hora de llegada.",
  guestsByArrivalTime: "Huéspedes por hora de llegada",
  arrivalTimeSummary: "Resumen de horas de llegada",
  guestRegistration: "Registro de huéspedes",
  registeredGuests: "Huéspedes registrados",
  totalGuests: "Total de huéspedes",
  guestCount: "Número de huéspedes",
  peakHour: "Hora punta",
  noArrivalTimeData: "No hay llegadas para esta fecha.",
  bothGuestTypes: "Ambos",
  filter: "Filtrar",
  clearAll: "Borrar todo",
  apply: "Aplicar",
  pickADate: "Elige una fecha",
  last7Days: "Últimos 7 días",
  last30Days: "Últimos 30 días",
  last90Days: "Últimos 90 días",
  customRange: "Rango personalizado",
  totalReservedGuests: "Total de huéspedes reservados",
  totalPreCheckinGuests: "Total de huéspedes con pre-check-in",
  waitForPreCheckinGuests: "Huéspedes pendientes de pre-check-in",
  reservationCode: "Código de reserva",
  reservationDetails: "Detalles de la reserva",
  reservationNo: "Nº de reserva",
  reservationSummary: "Resumen de reservas",
  formCompletion: "Formularios completados",
  manifestPublicLink: "Enlace público del manifiesto",
  identificationType: "Tipo de identificación",
  idNumber: "Número de identificación",
  idScan: "Escaneo de identificación",
  medicalCondition: "Condición médica",
  foodAllergies: "Alergias alimentarias",
  specialNotes: "Notas especiales",
  freeCredit: "Crédito gratuito",
  guestNumber: "Huésped {0}",
  seatsForZone: "{0} asientos para {1}",
  seatsQuantity: "{0} asientos",
  clickHereLink: "Haga clic aquí",
  zone: "Zona",
  ticket: "Billete",
  passport: "Pasaporte",
  nationalIdentificationCard: "Documento nacional de identidad",
  drivingLicense: "Permiso de conducir",
  package: "Paquete",
  reservationOriginalFreeCredit: "Crédito gratuito original de la reserva",
};
export default Object.freeze(locale);
